<template>
  <SidebarComponent />
  <div class="dashboard-layout staff-contacts-page">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Elenco Contatti</h1>
          <div class="alert-note">
            Gli ordini si sincronizzano con gli utenti ricercando il campo email.
          </div>
        </div>

        <div class="loader" v-if="isLoading">
          <h4>CREAZIONE IN CORSO</h4>
        </div>

        <transition name="reminder-toast">
          <div
            v-if="reminderVisible && activeReminder"
            class="reminder-toast"
          >
            <div class="reminder-toast__header">
              <span class="material-icons">notifications_active</span>
              <span>{{ activeReminder.typeLabel }}</span>
            </div>
            <div class="reminder-toast__name">{{ activeReminder.displayName }}</div>
            <div class="reminder-toast__meta">
              <span class="reminder-toast__time">{{ activeReminder.time }}</span>
              <span
                v-if="activeReminder.date"
                class="reminder-toast__date"
              >{{ formatDate(activeReminder.date) }}</span>
            </div>
          </div>
        </transition>

        <div class="accordion-container staff-contacts-search">
          <button
            type="button"
            class="contacts-search-toggle"
            @click="toggleAccordion"
            :aria-expanded="isAccordionOpen"
            aria-controls="contacts-search-fields"
          >
            <span class="material-icons" aria-hidden="true">search</span>
            <span class="contacts-search-heading">
              <strong>Ricerca contatti</strong>
              <small>Anagrafica, date e promemoria.</small>
            </span>
            <span class="material-icons" aria-hidden="true">{{ isAccordionOpen ? 'expand_less' : 'expand_more' }}</span>
          </button>

          <div id="contacts-search-fields" v-show="isAccordionOpen" class="contacts-search-panel">
            <form class="contacts-search-form" @submit.prevent="applyFilters">
              <fieldset class="contacts-search-section">
                <legend>Contatti</legend>
                <div class="contacts-search-identity">
                  <label class="contacts-search-field">
                    <span>Cognome</span>
                    <input type="text" v-model="searchSurname" placeholder="Cognome" aria-label="Cerca per cognome">
                  </label>
                  <label class="contacts-search-field">
                    <span>Email</span>
                    <input type="text" inputmode="email" v-model="searchEmail" placeholder="Email" aria-label="Cerca per email">
                  </label>
                  <label class="contacts-search-field">
                    <span>Telefono</span>
                    <input type="text" inputmode="tel" v-model="searchPhone" placeholder="Telefono" aria-label="Cerca per telefono">
                  </label>
                </div>
              </fieldset>

              <div class="contacts-search-periods">
                <fieldset class="contacts-search-period">
                  <legend>Data creazione</legend>
                  <div class="contacts-search-dates">
                    <label class="contacts-search-field">
                      <span>Dal</span>
                      <input type="date" v-model="startDate" aria-label="Data creazione da">
                    </label>
                    <label class="contacts-search-field">
                      <span>Al</span>
                      <input type="date" v-model="endDate" aria-label="Data creazione a">
                    </label>
                  </div>
                </fieldset>
                <fieldset class="contacts-search-period">
                  <legend>Data lavorazione</legend>
                  <div class="contacts-search-dates">
                    <label class="contacts-search-field">
                      <span>Dal</span>
                      <input type="date" v-model="startDateLavorato" aria-label="Data lavorazione da">
                    </label>
                    <label class="contacts-search-field">
                      <span>Al</span>
                      <input type="date" v-model="endDateLavorato" aria-label="Data lavorazione a">
                    </label>
                  </div>
                </fieldset>
              </div>
              <div class="contacts-search-actions">
                <p>Per le date, indica sia Dal che Al.</p>
                <button type="submit" class="contacts-search-button contacts-search-button--primary">
                  <span class="material-icons" aria-hidden="true">search</span>
                  <span>Cerca contatti</span>
                </button>
              </div>
            </form>

            <form class="contacts-search-form contacts-search-reminders" @submit.prevent="searchByCallDate">
              <fieldset class="contacts-search-section">
                <legend>Promemoria</legend>
                <div class="contacts-search-reminder-controls">
                  <div class="contacts-search-dates">
                  <label class="contacts-search-field">
                    <span>Dal</span>
                    <input type="date" v-model="startDateCall" aria-label="Data promemoria da">
                  </label>
                  <label class="contacts-search-field">
                    <span>Al</span>
                    <input type="date" v-model="endDateCall" aria-label="Data promemoria a">
                  </label>
                  </div>
                  <button type="submit" class="contacts-search-button contacts-search-button--primary">
                    <span class="material-icons" aria-hidden="true">search</span>
                    <span>Cerca promemoria</span>
                  </button>
                </div>
              </fieldset>
            </form>

            <footer class="contacts-search-footer">
              <p>Azzera i campi e torna ai contatti recenti.</p>
              <button type="button" class="contacts-search-button contacts-search-button--reset" @click="resetSearch">
                <span class="material-icons" aria-hidden="true">restart_alt</span>
                <span>Azzera ricerca</span>
              </button>
            </footer>
          </div>
        </div>


<div class="search-container contacts-mobile-toolbar">
          <button @click="openCreateContactModal" class="create-user-button staff-button-positive" aria-label="Nuovo contatto" title="Nuovo contatto"><span class="material-icons" aria-hidden="true">add_circle_outline</span><span class="contacts-mobile-only">Nuovo</span></button>
          <button @click="openMultiContactModal" class="create-user-button staff-button-positive" aria-label="Inserisci contatti multipli" title="Inserisci contatti multipli"><span class="material-icons" aria-hidden="true">control_point_duplicate</span><span class="contacts-mobile-only">Multipli</span></button>
          <button @click="openCsvImportModal" class="create-user-button csv-import-button staff-button-positive" aria-label="Importa CSV" title="Importa CSV">
            <span class="material-icons" aria-hidden="true">upload_file</span>
            CSV
          </button>
          <button @click="openFiltriContactModal" class="create-user-button staff-button-neutral" aria-label="Filtri contatti" title="Filtri contatti"><span class="material-icons" aria-hidden="true">tune</span><span class="contacts-mobile-only">Filtri</span></button>
<button @click="openMultiStatistic" class="create-user-button staff-button-neutral" aria-label="Statistiche contatti" title="Statistiche contatti"><span class="material-icons" aria-hidden="true">insights</span><span class="contacts-mobile-only">Statistiche</span></button>
<button
  @click="openCalendarView"
  class="create-user-button agenda-button staff-button-neutral"
  :disabled="isAgendaLoading"
  aria-label="Agenda contatti"
  title="Agenda contatti"
>
  <span class="material-icons" aria-hidden="true">calendar_month</span>
  Agenda
</button>
<button @click="exportToCSV" class="create-user-button staff-button-neutral" aria-label="Esporta contatti in CSV" title="Esporta contatti in CSV"><span class="material-icons" aria-hidden="true">download</span> Export.csv</button>

        </div>

        <div class="tickets">
          <table class="contacts-table">
            <thead>
              <tr>
                <th class="actions-column">Azione</th>
                <th class="data-column created-date-column">Data</th>
                <th>Contatto</th>
                <th>Ex cliente</th>
                <th>Lavorato</th>
                 <th>Lav. il</th>

                <th>Note</th>
        <th class="sticky-col col-1">Nome</th>
        <th class="sticky-col col-2">Cognome</th>
                <th>Telefono</th>
                <th>Email</th>
                <th>Città</th>
                <th>Regione</th>
                                <th>Pref. contatto</th>

                <th>Come</th>
      <th class="blue-separator"></th>
                      <th>Da ricontattare</th>
                                            <th>Orario preferenza</th>
                <th class="agenda-status-column">Stato agenda</th>
                                                            <th>RECAP CHIAMATA</th>
                <th>Esito chiamata</th>
                <th class="blue-separator"></th>
<th>2° Data chiamata</th>
<th>2° Orario pref.</th>
<th class="agenda-status-column">2° Stato agenda</th>
<th>2° Recap chiamata</th>
<th>2° Esito chiamata</th>
<th class="blue-separator"></th>

                <th>€€</th>
                <th>Acq. il</th>
                <th>Studio</th>
                <th>Importo (€)</th>
                <th>Ordine</th>

              </tr>
            </thead>
            <tbody>

              <tr
  v-for="contact in filteredContacts"
  :key="contact.uid"
  :class="{
    'popup-row': isFromPopup(contact),
    'orange-row': [].includes(contact.stato3 || contact.stato2),
    'green-row': [].includes(contact.stato3 || contact.stato2 || contact.stato),
    'red-row': contact.stato2 === 'non interessata' || contact.stato3 === 'non interessata',
    'purple-row': (contact.stato3 || contact.stato2) === 'da ricontattare',
    'highlighted-contact': String(contact.uid || contact.id || '') === highlightedContactId,
    'contact-mobile-expanded': isMobileContactExpanded(contact)
  }"
  :data-contact-id="contact.uid || contact.id"
>

<td class="actions-column contacts-cell-actions" data-label="Azioni">
  <div class="buttons-container">
    <!-- Badge match -->
<!-- Badge match per i contatti provenienti dai form esterni; mostra '?' quando nessun match -->
<span
  v-if="shouldShowMatchBadge(contact)"
  class="match-badge"
  :class="{
    'match-strong': matchStrengthOf(contact) === 'strong',
    'match-email':  matchStrengthOf(contact) === 'email',
    'match-phone':  matchStrengthOf(contact) === 'phone',
    'match-none':   matchStrengthOf(contact) === 'none'
  }"
  :title="matchTitle(contact)"
>
  <span class="material-icons" v-if="matchStrengthOf(contact) === 'strong'">link</span>
  <span class="material-icons" v-else-if="matchStrengthOf(contact) === 'email'">mail</span>
  <span class="material-icons" v-else-if="matchStrengthOf(contact) === 'phone'">phone</span>
  <span class="material-icons" v-else>help_outline</span> <!-- '?' -->
</span>

    <!-- Link profilo -->
    <a
      v-if="contact._matchedUserUid"
      :href="getUserProfileLink(contact)"
      class="profile-link"
      target="_blank"
      rel="noopener"
      :title="`Apri profilo utente (${contact._matchedUserUid})`"
      aria-label="Apri profilo utente"
    >
      <span class="material-icons">visibility</span>
    </a>

    <button
      type="button"
      class="action-button"
      @click="openContactReminderModal(contact)"
      title="Crea promemoria contatto"
      aria-label="Crea promemoria contatto"
    >
      <span class="material-icons">alarm_add</span>
    </button>

    <button
      type="button"
      class="action-button action-button--danger"
      @click="deleteContact(contact)"
      title="Elimina contatto"
      aria-label="Elimina contatto"
    >
      <span class="material-icons">delete</span>
    </button>
  </div>
</td>
<td class="data-column created-date-column contacts-cell-created contacts-mobile-secondary" data-label="Data creazione">
  <div class="date-field-container">
    <span>{{ formatDate(contact.created_time) }}</span>
    <input
      type="date"
      :value="contact.created_time
        ? contact.created_time.toDate().toISOString().substr(0,10)
        : ''"
      @change="handleCreatedDateChange(contact, $event.target.value)"
      class="hidden-date-input"
    />
  </div>
</td>
    <td class="contacts-cell-source contacts-mobile-secondary" data-label="Provenienza">{{ contact.contattopreso }}</td>

    <td class="contacts-cell-ex-client contacts-mobile-secondary" data-label="Ex cliente">
      <label class="lavorato-cell">
        <input
          type="checkbox"
          :checked="!!contact.excliente"
          @change="toggleExCliente(contact, $event.target.checked)"
        />
        <span>{{ contact.excliente ? 'Sì' : 'No' }}</span>
      </label>
    </td>


        <!-- NUOVA CELLA: Lavorato -->
    <td class="contacts-cell-worked" data-label="Lavorato">
      <label class="lavorato-cell">
        <input
          type="checkbox"
          :checked="!!contact.lavorato"
          @change="toggleLavorato(contact, $event.target.checked)"
        />
        <span>{{ contact.lavorato ? 'Sì' : 'No' }}</span>
      </label>
    </td>

    <!-- NUOVA CELLA: Lav. il -->
    <td class="contacts-cell-worked-at contacts-mobile-secondary" data-label="Lavorato il">
      <span>{{ contact.lavoratoAt ? formatDate(contact.lavoratoAt) : '—' }}</span>
    </td>

          <td class="note-cell contacts-cell-notes" data-label="Note">
      <button
        type="button"
        class="note-icon-button"
        :class="{ 'note-icon-button--active': !!getContactNoteValue(contact) }"
        :data-note="getContactNoteValue(contact)"
        @click="openNoteEditor(contact)"
        aria-label="Apri note contatto"
        title="Apri note contatto"
      >
        <span class="material-icons">edit_note</span>
      </button>
    </td>


        <td class="sticky-col col-1 contacts-cell-name contacts-desktop-identity" data-label="Nome">{{ contact.name }}</td>

                <td class="sticky-col col-2 contacts-cell-surname contacts-desktop-identity" data-label="Cognome">{{ contact.surname }}</td>


        <!--
<td class="sticky-col col-2">
    <input
      type="texttable"
      v-model="contact.surname"
      @change="updateContactField(contact, 'surname')"
      placeholder="Cognome"
      class="search-bar"
    />
  </td>
  -->



    <td class="contacts-cell-phone" data-label="Telefono">
      <input type="textnumber" inputmode="tel" aria-label="Telefono" v-model="contact.telefono" @change="updateContactField(contact, 'telefono')">
    </td>
    <td class="contacts-cell-email" data-label="Email">
      <input type="texttable" inputmode="email" aria-label="Email" v-model="contact.email" @change="updateContactField(contact, 'email')" placeholder="Inserisci email">
    </td>
    <td class="contacts-cell-city contacts-mobile-secondary" data-label="Città">
      <input type="texttable" v-model="contact.citta" @change="updateContactField(contact, 'citta')" placeholder="Città">
    </td>

    <td class="contacts-cell-region contacts-mobile-secondary" data-label="Regione">
  <select v-model="contact.regione" @change="updateContactField(contact, 'regione')">
    <option value="">Seleziona una regione</option>
    <option value="abruzzo">Abruzzo</option>
    <option value="basilicata">Basilicata</option>
    <option value="calabria">Calabria</option>
    <option value="campania">Campania</option>
    <option value="emilia-romagna">Emilia-Romagna</option>
    <option value="friuli-venezia-giulia">Friuli-Venezia Giulia</option>
    <option value="lazio">Lazio</option>
    <option value="liguria">Liguria</option>
    <option value="lombardia">Lombardia</option>
    <option value="marche">Marche</option>
    <option value="molise">Molise</option>
    <option value="piemonte">Piemonte</option>
    <option value="puglia">Puglia</option>
    <option value="sardegna">Sardegna</option>
    <option value="sicilia">Sicilia</option>
    <option value="toscana">Toscana</option>
    <option value="trentino-alto-adige">Trentino-Alto Adige</option>
    <option value="umbria">Umbria</option>
    <option value="valle-d-aosta">Valle d'Aosta</option>
    <option value="veneto">Veneto</option>
  </select>
</td>


    <td class="contacts-cell-preference contacts-mobile-secondary" data-label="Preferenza contatto">
  <select v-model="contact.prefcontatto" @change="updateContactField(contact, 'prefcontatto')">
    <option value="">Seleziona la preferenza</option>
    <option value="telefono">Telefono</option>
    <option value="whatsapp">Whatsapp</option>
  </select>
</td>





        <td class="contacts-cell-status contacts-mobile-secondary" data-label="Stato contatto">
      <select v-model="contact.stato" @change="updateContactField(contact, 'stato')">
        <option value="">Seleziona uno stato</option>
        <option value="inviato messaggio">Inviato messaggio WA</option>
        <option value="appuntamento telefonico">Appuntamento Telefonico</option>
        <option value="appuntamento studio">Appuntamento studio</option>
        <option value="interessato online">Interessato online</option>
        <option value="interessato ma non al momento">Interessato ma non al momento</option>
          <option value="gia attiva">Già attiva</option>
        <option value="da ricontattare">Da ricontattare</option>
        <option value="chiamare a settembre">Chiamare a settembre</option>
        <option value="mai risposto">Mai risposto</option>
        <option value="ghosting">Ghosting</option>
        <option value="non risponde">Non risponde</option>
        <option value="non interessata">Non interessata</option>
      </select>
    </td>






          <td class="blue-separator"></td>
                  
<td class="contacts-cell-reminder-date" data-label="Da ricontattare">
  <div class="date-field-container">
    <span>
      {{ contact.dataricontatto2 ? formatDate(contact.dataricontatto2) : 'Data promemoria' }}
    </span>
    <!-- input sempre presente, ma invisibile e assoluto -->
    <input
      type="date"
      v-model="contact.dataricontatto2"
      @change="handleDateChange(contact, 'dataricontatto2')"
      class="hidden-date-input"
    />
    <button
      v-if="hasReminderData(contact, 'dataricontatto2', 'orario')"
      type="button"
      class="date-reset-button"
      @click.stop="resetReminderFields(contact, 'dataricontatto2', 'orario')"
      title="Reset data e orario"
      aria-label="Reset data e orario"
    >
      <span class="material-icons">close</span>
    </button>
  </div>
</td>



  <td class="contacts-cell-reminder-time" data-label="Orario preferenza">
    <select v-model="contact.orario" @change="updateContactField(contact, 'orario')">
      <option value="">Seleziona orario</option>
      <option v-for="time in timeOptions" :key="time" :value="time">
        {{ time }}
      </option>
    </select>
  </td>



  <td class="agenda-status-cell contacts-cell-agenda-status contacts-mobile-secondary" data-label="Stato agenda">
    <div
      class="agenda-status-controls"
      :class="{
        'agenda-status-controls--updating': isCalendarStatusUpdating(contact, 'calendarStatus2'),
        'agenda-status-controls--empty': !normalizeCalendarStatus(contact.calendarStatus2)
      }"
      role="group"
      :aria-label="`Stato agenda prima chiamata di ${contact.name || ''} ${contact.surname || ''}`.trim()"
    >
      <button
        v-for="option in calendarStatusOptions"
        :key="option.value"
        type="button"
        class="agenda-status-button"
        :class="[
          `agenda-status-button--${option.value}`,
          { 'agenda-status-button--active': isCalendarStatusSelected(contact, 'calendarStatus2', option.value) }
        ]"
        :style="{ '--agenda-status-color': option.color }"
        :disabled="isCalendarStatusUpdating(contact, 'calendarStatus2')"
        :aria-pressed="isCalendarStatusSelected(contact, 'calendarStatus2', option.value)"
        :aria-label="option.label"
        :title="isCalendarStatusSelected(contact, 'calendarStatus2', option.value)
          ? `${option.label} · clicca per rimuovere`
          : option.label"
        @click.stop="toggleCalendarStatus(contact, 'calendarStatus2', option.value)"
      >
        <span class="material-icons" aria-hidden="true">{{ option.icon }}</span>
      </button>
    </div>
  </td>





    <td class="contacts-cell-recap contacts-mobile-secondary" data-label="Recap chiamata">
  <button
    @click="openTextModal(contact)"
    class="details-button"
  >
    DETTAGLI
  </button>
</td>



    <td class="contacts-cell-outcome contacts-mobile-secondary" data-label="Esito chiamata">
      <select v-model="contact.stato2" @change="updateContactField(contact, 'stato2')">
        <option value="">Seleziona uno stato</option>
        <option value="da ricontattare">Da ricontattare</option>
        <option value="chiamare a settembre">Chiamare a settembre</option>
        <option value="fissato app in studio">Fissato App in studio</option>
        <option value="telefonata riprogrammata">Telefonata Riprogrammata</option>
        <option value="mai risposto">Mai risposto</option>
        <option value="In Attesa di finalizzazione">In Attesa di Finalizzazione</option>
        <option value="non risponde">Non risponde</option>
        <option value="non interessata">Non interessata</option>


      </select>
    </td>



<td class="blue-separator"></td>

<!-- 2° Data chiamata -->
<td class="contacts-cell-second-reminder-date contacts-mobile-secondary" data-label="2° Data chiamata">
  <div class="date-field-container">
    <span>
      {{ contact.dataricontatto3 ? formatDate(contact.dataricontatto3) : 'Data promemoria' }}
    </span>
    <input
      type="date"
      v-model="contact.dataricontatto3"
      @change="handleDateChange(contact, 'dataricontatto3')"
      class="hidden-date-input"
    />
    <button
      v-if="hasReminderData(contact, 'dataricontatto3', 'orario2')"
      type="button"
      class="date-reset-button"
      @click.stop="resetReminderFields(contact, 'dataricontatto3', 'orario2')"
      title="Reset data e orario"
      aria-label="Reset data e orario"
    >
      <span class="material-icons">close</span>
    </button>
  </div>
</td>

<!-- 2° Orario pref. -->

  <td class="contacts-cell-second-reminder-time contacts-mobile-secondary" data-label="2° Orario preferenza">
    <select v-model="contact.orario2" @change="updateContactField(contact, 'orario2')">
      <option value="">Seleziona orario</option>
      <option v-for="time in timeOptions" :key="time" :value="time">
        {{ time }}
      </option>
    </select>
  </td>



<td class="agenda-status-cell contacts-cell-second-agenda-status contacts-mobile-secondary" data-label="2° Stato agenda">
  <div
    class="agenda-status-controls"
    :class="{
      'agenda-status-controls--updating': isCalendarStatusUpdating(contact, 'calendarStatus3'),
      'agenda-status-controls--empty': !normalizeCalendarStatus(contact.calendarStatus3)
    }"
    role="group"
    :aria-label="`Stato agenda seconda chiamata di ${contact.name || ''} ${contact.surname || ''}`.trim()"
  >
    <button
      v-for="option in calendarStatusOptions"
      :key="option.value"
      type="button"
      class="agenda-status-button"
      :class="[
        `agenda-status-button--${option.value}`,
        { 'agenda-status-button--active': isCalendarStatusSelected(contact, 'calendarStatus3', option.value) }
      ]"
      :style="{ '--agenda-status-color': option.color }"
      :disabled="isCalendarStatusUpdating(contact, 'calendarStatus3')"
      :aria-pressed="isCalendarStatusSelected(contact, 'calendarStatus3', option.value)"
      :aria-label="option.label"
      :title="isCalendarStatusSelected(contact, 'calendarStatus3', option.value)
        ? `${option.label} · clicca per rimuovere`
        : option.label"
      @click.stop="toggleCalendarStatus(contact, 'calendarStatus3', option.value)"
    >
      <span class="material-icons" aria-hidden="true">{{ option.icon }}</span>
    </button>
  </div>
</td>



<!-- 2° Recap (modal) -->
<td class="contacts-cell-second-recap contacts-mobile-secondary" data-label="2° Recap chiamata">
  <button
    @click="openTextModalSecond(contact)"
    class="details-button"
  >DETTAGLI</button>
</td>

<!-- 2° Stato -->
<td class="contacts-cell-second-outcome contacts-mobile-secondary" data-label="2° Esito chiamata">
  <select
    v-model="contact.stato3"
    @change="updateContactField(contact, 'stato3')"
  >
    <option value="">Seleziona uno stato</option>
    <option value="da ricontattare">Da ricontattare</option>
    <option value="chiamare a settembre">Chiamare a settembre</option>
    <option value="fissato app in studio">Fissato App in studio</option>
    <option value="telefonata riprogrammata">Telefonata Riprogrammata</option>
    <option value="mai risposto">Mai risposto</option>
    <option value="In Attesa di finalizzazione">In Attesa di Finalizzazione</option>
    <option value="non risponde">Non risponde</option>
    <option value="non interessata">Non interessata</option>
  </select>
</td>

<td class="blue-separator"></td>
                 

    <td class="contacts-cell-purchased contacts-mobile-secondary" data-label="Acquistato">
      <label class="lavorato-cell">
        <input
          type="checkbox"
          :checked="isAcquistato(contact)"
          :disabled="hasOrderMatch(contact)"
          @change="toggleAcquistato(contact, $event.target.checked)"
        />
        <span>{{ isAcquistato(contact) ? 'Sì' : 'No' }}</span>
      </label>
    </td>

    <td class="contacts-cell-purchase-date contacts-mobile-secondary" data-label="Acquistato il">
      <div class="date-field-container">
        <span>{{ getAcquistoDate(contact) ? formatDate(getAcquistoDate(contact)) : '—' }}</span>
        <input
          type="date"
          :value="toInputDateValue(getAcquistoDate(contact))"
          :disabled="hasOrderMatch(contact)"
          @change="handleAcquistoDateChange(contact, $event.target.value)"
          class="hidden-date-input"
        />
      </div>
    </td>


        <td class="contacts-cell-studio contacts-mobile-secondary" data-label="Studio">
      <select v-model="contact.studio" @change="updateContactField(contact, 'studio')">
        <option value="">Seleziona uno studio</option>
        <option value="Tivoli Quartier generale">Tivoli Quartier generale</option>
        <option value="FF Genova">FF Genova</option>
        <option value="FF Bologna">FF Bologna</option>
        <option value="FF Bari">FF Bari</option>
        <option value="FF Pescara">FF Pescara</option>
        <option value="FF Firenze">FF Firenze</option>
        <option value="FF Torino">FF Torino</option>
        <option value="FF Napoli">FF Napoli</option>
        <option value="FF Milano">FF Milano</option>
        <option value="FF Milano Sempione">FF Milano Sempione</option>
        <option value="FF Milano Citta Studi">FF Milano Città Studi</option>
        <option value="FF Roma">FF Roma</option>
        <option value="FF Roma Eur">FF Roma Eur</option>
        <option value="FF Salerno">FF Salerno</option>
        <option value="FF Cagliari">FF Cagliari</option>
        <option value="FF Padova">FF Padova</option>
      </select>
    </td>


        <td class="contacts-cell-amount contacts-mobile-secondary" data-label="Importo (€)">
      <template v-if="hasOrderMatch(contact)">
        <span>{{ formatPrice(getImportoValue(contact)) || '—' }}</span>
      </template>
      <template v-else>
        <input
          type="texttable"
          v-model="contact.importo"
          @change="updateContactField(contact, 'importo')"
          placeholder="Importo"
        >
      </template>
    </td>
    <td class="order-link-cell contacts-cell-order contacts-mobile-secondary" data-label="Ordine">
      <a
        v-if="orderLink(contact)"
        :href="orderLink(contact)"
        class="order-link"
        target="_blank"
        rel="noopener"
        title="Apri ordine"
      >
        <span class="material-icons">open_in_new</span>
      </a>
      <span v-else>—</span>
    </td>



    <td class="contacts-mobile-only contacts-mobile-identity" data-label="Contatto">
      {{ [contact.name, contact.surname].filter(Boolean).join(' ') || 'Contatto senza nome' }}
    </td>
    <td class="contacts-mobile-only contacts-mobile-footer">
      <button
        type="button"
        class="contacts-mobile-details-toggle"
        :aria-expanded="isMobileContactExpanded(contact)"
        @click="toggleMobileContactDetails(contact)"
      >
        {{ isMobileContactExpanded(contact) ? 'Meno campi' : 'Altri campi' }}
        <span class="material-icons" aria-hidden="true">{{ isMobileContactExpanded(contact) ? 'expand_less' : 'expand_more' }}</span>
      </button>
    </td>
  </tr>
</tbody>

          </table>
        </div>
      </div>
    </div>
</div>

<div class="modal contacts-mobile-modal calendar-modal" v-if="showCalendarView" @click.self="closeCalendarView">
  <div class="modal-content contacts-mobile-modal__panel calendar-content staff-editor-dialog staff-contact-dialog staff-contact-dialog--wide" role="dialog" aria-modal="true" aria-labelledby="contacts-agenda-title" aria-describedby="contacts-agenda-description" @click.stop>
    <header class="staff-editor-header">
      <span class="material-icons staff-editor-heading-icon" aria-hidden="true">calendar_month</span>
      <div>
        <h2 id="contacts-agenda-title">Agenda contatti</h2>
        <p id="contacts-agenda-description">Promemoria e chiamate organizzati per settimana.</p>
      </div>
      <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi agenda contatti" title="Chiudi agenda contatti" @click="closeCalendarView">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>
    <div class="staff-editor-form">
      <div class="staff-editor-body">
    <div v-if="isAgendaLoading" class="calendar-loading">
      <div class="calendar-loading__spinner"></div>
      <div class="calendar-loading__label">Caricamento agenda…</div>
    </div>
    <template v-else>
      <div class="calendar-toolbar staff-editor-section">
        <div class="calendar-toolbar__group">
          <button type="button" class="calendar-toolbar__button" @click="goToPreviousWeek">
            <span class="material-icons" aria-hidden="true">chevron_left</span>
            <span>Settimana precedente</span>
          </button>
          <button type="button" class="calendar-toolbar__button" @click="goToCurrentWeek">
            <span class="material-icons" aria-hidden="true">today</span>
            <span>Settimana corrente</span>
          </button>
          <button type="button" class="calendar-toolbar__button" @click="goToNextWeek">
            <span class="material-icons" aria-hidden="true">chevron_right</span>
            <span>Settimana successiva</span>
          </button>
        </div>
        <div class="calendar-toolbar__info">
          <span class="calendar-range">{{ calendarRangeLabel }}</span>
          <span v-if="isCalendarManualRange" class="calendar-toolbar__badge">Intervallo manuale</span>
        </div>
      </div>

      <div v-if="!calendarHasEvents" class="calendar-empty">
        Nessun contatto con promemoria da ricontattare.
      </div>
      <div v-else class="calendar-grid">
        <div
          v-for="column in calendarEvents"
          :key="column.dateKey"
          class="calendar-column"
        >
          <div class="calendar-column-header">
            <div class="calendar-date">{{ column.dateLabel }}</div>
            <div class="calendar-date-secondary">{{ formatDate(column.dateObj) }}</div>
          </div>
          <div
            v-for="item in column.items"
            :key="item.id"
            :class="['calendar-event', { 'calendar-event--second': item.type === 'second' }]"
          >
            <div class="calendar-time">{{ item.displayTime }}</div>
            <div class="calendar-info">
              <div class="calendar-type" :class="{ 'calendar-type--second': item.type === 'second' }">
                {{ item.typeLabel }}
              </div>
              <div class="calendar-name">{{ item.displayName }}</div>
              <div class="calendar-details">
                <span v-if="item.phone">{{ item.phone }}</span>
                <span v-if="item.email">{{ item.email }}</span>
                <span v-if="item.operatore" class="calendar-chip calendar-chip--primary">
                  <span class="material-icons">person</span>
                  {{ item.operatore }}
                </span>
                <span v-if="item.operatoreSecondario" class="calendar-chip calendar-chip--secondary">
                  <span class="material-icons">group</span>
                  {{ item.operatoreSecondario }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
      </div>
      <footer class="staff-editor-footer">
        <p>Seleziona una settimana per consultare i promemoria dei contatti.</p>
        <div class="staff-editor-actions">
          <button type="button" class="staff-editor-button staff-button-neutral" @click="closeCalendarView">Chiudi</button>
        </div>
      </footer>
    </div>
  </div>
</div>

<div
  v-if="showReminderModal && reminderModalContact"
  class="modal contacts-mobile-modal contact-reminder-modal"
  @click.self="closeContactReminderModal"
>
  <div class="modal-content contacts-mobile-modal__panel contact-reminder-modal__content staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-labelledby="staff-contact-reminder-title" @click.stop>
    <header class="staff-editor-header">
      <span class="material-icons staff-editor-heading-icon" aria-hidden="true">add_alarm</span>
      <div>
        <h2 id="staff-contact-reminder-title">Crea promemoria</h2>
        <p>Scegli quando ricontattare la persona e a chi assegnarla.</p>
      </div>
      <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi finestra" @click="closeContactReminderModal">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>
    <form class="contact-reminder-form staff-editor-form" @submit.prevent="saveContactReminder">
      <div class="staff-editor-body">
        <fieldset class="staff-editor-section">
          <legend>Contatto</legend>
          <div class="staff-contact-summary">
            <strong>{{ reminderModalContact.name }} {{ reminderModalContact.surname }}</strong>
            <span v-if="reminderModalContact.email">{{ reminderModalContact.email }}</span>
            <span v-if="reminderModalContact.telefono">{{ reminderModalContact.telefono }}</span>
          </div>
        </fieldset>
        <fieldset class="staff-editor-section">
          <legend>Promemoria</legend>
          <div class="staff-editor-grid staff-editor-grid--two">
            <label class="staff-editor-field">
              <span>Data e ora*</span>
              <input type="datetime-local" v-model="reminderForm.dueAt" required />
            </label>
            <label class="staff-editor-field">
              <span>Nota</span>
              <textarea v-model="reminderForm.note" rows="2" placeholder="Es. Richiamare per promo"></textarea>
            </label>
          </div>
        </fieldset>
        <fieldset class="staff-editor-section">
          <legend>Consulente</legend>
          <div class="staff-editor-grid staff-editor-grid--two">
            <label class="staff-editor-field">
              <span>Nome consulente</span>
              <input type="text" v-model="reminderForm.consultantName" placeholder="Es. Paolo Marchini" />
            </label>
            <label class="staff-editor-field">
              <span>Email consulente*</span>
              <input type="email" v-model="reminderForm.consultantEmail" placeholder="consulente@email.com" required />
            </label>
          </div>
        </fieldset>
      </div>
      <footer class="staff-editor-footer">
        <p>I campi con * sono obbligatori.</p>
        <div class="staff-editor-actions">
          <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeContactReminderModal">Annulla</button>
          <button type="submit" class="staff-editor-button staff-editor-save staff-button-positive" :disabled="isSavingReminder">
            <span class="material-icons" aria-hidden="true">check</span>
            <span>{{ isSavingReminder ? 'Salvataggio…' : 'Salva promemoria' }}</span>
          </button>
        </div>
      </footer>
    </form>
  </div>
</div>

<!-- Modale per le informazioni del contatto e della prima chiamata -->
<div class="modal contacts-mobile-modal modal-new-info" v-if="showModal5">
  <div class="modal-content contacts-mobile-modal__panel staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-labelledby="staff-contact-details-title">
    <header class="staff-editor-header">
      <span class="material-icons staff-editor-heading-icon" aria-hidden="true">description</span>
      <div>
        <h2 id="staff-contact-details-title">Informazioni contatto</h2>
        <p>Anagrafica, percorso e dettagli della prima chiamata.</p>
      </div>
      <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi finestra" @click="closeTextModal">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>
    <form class="staff-editor-form" @submit.prevent="saveTextField">
      <div class="staff-editor-body">
      <fieldset class="staff-editor-section">
        <legend>Dati contatto</legend>
        <div class="staff-editor-grid staff-editor-grid--two">
          <label class="staff-editor-field" for="contacts-modal-field-1">
            <span>Nome</span>
            <input id="contacts-modal-field-1"
              type="text"
              v-model="currentContact.name"
              @blur="updateContactField(currentContact, 'name')"
              placeholder="Nome"
            />
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-2">
            <span>Cognome</span>
            <input id="contacts-modal-field-2"
              type="text"
              v-model="currentContact.surname"
              @blur="updateContactField(currentContact, 'surname')"
              placeholder="Cognome"
            />
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-3">
            <span>Email</span>
            <input id="contacts-modal-field-3"
              type="text"
              v-model="currentContact.email"
              @blur="updateContactField(currentContact, 'email')"
              placeholder="Email"
            />
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-4">
            <span>Telefono</span>
            <input id="contacts-modal-field-4"
              type="text"
              v-model="currentContact.telefono"
              @blur="updateContactField(currentContact, 'telefono')"
              placeholder="Telefono"
            />
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-5">
            <span>Città</span>
            <input id="contacts-modal-field-5"
              type="text"
              v-model="currentContact.citta"
              @blur="updateContactField(currentContact, 'citta')"
              placeholder="Citta"
            />
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-6">
            <span>Regione</span>
            <select id="contacts-modal-field-6"
              v-model="currentContact.regione"
              @change="updateContactField(currentContact, 'regione')"
            >
              <option value="">Seleziona una regione</option>
              <option value="abruzzo">Abruzzo</option>
              <option value="basilicata">Basilicata</option>
              <option value="calabria">Calabria</option>
              <option value="campania">Campania</option>
              <option value="emilia-romagna">Emilia-Romagna</option>
              <option value="friuli-venezia-giulia">Friuli-Venezia Giulia</option>
              <option value="lazio">Lazio</option>
              <option value="liguria">Liguria</option>
              <option value="lombardia">Lombardia</option>
              <option value="marche">Marche</option>
              <option value="molise">Molise</option>
              <option value="piemonte">Piemonte</option>
              <option value="puglia">Puglia</option>
              <option value="sardegna">Sardegna</option>
              <option value="sicilia">Sicilia</option>
              <option value="toscana">Toscana</option>
              <option value="trentino-alto-adige">Trentino-Alto Adige</option>
              <option value="umbria">Umbria</option>
              <option value="valle-d-aosta">Valle d'Aosta</option>
              <option value="veneto">Veneto</option>
            </select>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-7">
            <span>Età</span>
            <input id="contacts-modal-field-7"
              type="text"
              v-model="currentContact.eta"
              @blur="updateContactField(currentContact, 'eta')"
              placeholder="Eta"
            />
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-9">
            <span>Come ci hai conosciuto</span>
            <select id="contacts-modal-field-9" v-model="contactField.knownFrom">
                    <option value="">Seleziona</option>
                    <option value="instagram">Instagram</option>
                    <option value="facebook">Facebook</option>
                    <option value="google">Google</option>
                    <option value="passaparola">Passaparola</option>
                    <option value="excliente">Ex Cliente</option>

                  </select>
          </label>
        </div>
      </fieldset>
      <fieldset class="staff-editor-section">
        <legend>Percorso e indicazioni</legend>
        <div class="staff-editor-grid staff-editor-grid--two">
          <label class="staff-editor-field" for="contacts-modal-field-8">
            <span>Menopausa</span>
            <select id="contacts-modal-field-8"
              v-model="currentContact.menopausa"
              @change="updateContactField(currentContact, 'menopausa')"
            >
              <option value="">Seleziona</option>
              <option value="si">Si</option>
              <option value="no">No</option>
              <option value="Uomo">Uomo</option>

            </select>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-10">
            <span>Obiettivi</span>
            <select id="contacts-modal-field-10" v-model="contactField.objectives">
                    <option value="">Seleziona</option>
                    <option value="dimagrimento">Dimagrimento</option>
                    <option value="tonificazione">Tonificazione</option>
                    <option value="ricomposizione corporea">Ricomposizione corporea</option>
                  </select>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-11">
            <span>Esperienza di allenamento</span>
            <select id="contacts-modal-field-11" v-model="contactField.trainingExperience">
                    <option value="">Seleziona</option>
                    <option value="principiante">Principiante</option>
                    <option value="intermedia">Intermedia</option>
                    <option value="esperta">Esperta</option>
                  </select>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-12">
            <span>In quanto tempo pensi di ottenere il risultato di cui mi parli?</span>
            <select id="contacts-modal-field-12" v-model="contactField.resultTime">
                    <option value="">Seleziona</option>
                    <option value="1">1 mese</option>
                    <option value="3">3 mesi</option>
                    <option value="6">6 mesi</option>
                    <option value="12">12 mesi</option>
                  </select>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-13">
            <span>Patologie</span>
            <textarea id="contacts-modal-field-13"
              v-model="currentContact.pathologie"
              rows="4"
              placeholder="Patologie"
              @blur="updateContactField(currentContact, 'pathologie')"
            ></textarea>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-14">
            <span>Consigliato dalla consulente</span>
            <textarea id="contacts-modal-field-14"
              v-model="currentContact.consiglio"
              rows="4"
              placeholder="Consiglio"
              @blur="updateContactField(currentContact, 'consiglio')"
            ></textarea>
          </label>
        </div>
      </fieldset>
      <fieldset class="staff-editor-section">
        <legend>Chiamata</legend>
        <div class="staff-editor-grid staff-editor-grid--two">
          <label class="staff-editor-field" for="contacts-modal-field-15">
            <span>Note generali</span>
            <textarea id="contacts-modal-field-15"
              v-model="currentContact.note"
              rows="4"
              placeholder="Note generali"
              @blur="updateContactField(currentContact, 'note')"
            ></textarea>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-16">
            <span>Note chiamata</span>
            <textarea id="contacts-modal-field-16"
              v-model="currentContact.notecontatto1"
              rows="4"
              placeholder="Note Contatto"
              @blur="updateContactField(currentContact, 'notecontatto1')"
            ></textarea>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-17">
            <span>Esito della chiamata</span>
            <select id="contacts-modal-field-17"
              v-model="currentContact.stato2"
              @change="updateContactField(currentContact, 'stato2')"
            >
                  <option value="">Seleziona uno stato</option>
                  <option value="da ricontattare">Da ricontattare</option>
                  <option value="chiamare a settembre">Chiamare a settembre</option>
                  <option value="fissato app in studio">Fissato App in studio</option>
                  <option value="telefonata riprogrammata">Telefonata Riprogrammata</option>
                  <option value="mai risposto">Mai risposto</option>
                  <option value="In Attesa di finalizzazione">In Attesa di Finalizzazione</option>
                  <option value="non risponde">Non risponde</option>
                  <option value="non interessata">Non interessata</option>
            </select>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-18">
            <span>Operatore chiamata</span>
            <select id="contacts-modal-field-18"
              v-model="currentContact.operatore2"
              @change="updateContactField(currentContact, 'operatore2')"
            >
                  <option value="">Seleziona un operatore</option>
                  <option value="alessandro">Alessandro</option>
                  <option value="alessiofantini">Alessio Fantini</option>
                  <option value="Gaetano">Gaetano</option>
                  <option value="Luca">Luca Corbella</option>
                  <option value="Paolomarchini">Paolo Marchini</option>
                  <option value="Paoloramunno">Paolo Ramunno</option>
                  <option value="pasquale">Pasquale</option>
                  <option value="mirko">Mirko</option>
                  <option value="Roberta">Roberta</option>
                  <option value="Salvatore">Salvatore</option>
                </select>
          </label>
        </div>
      </fieldset>
      </div>
    <footer class="staff-editor-footer">
      <p>Salva per completare le informazioni della chiamata.</p>
      <div class="staff-editor-actions">
        <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeTextModal">Annulla</button>
        <button type="submit" class="staff-editor-button staff-editor-save staff-button-positive">
          <span class="material-icons" aria-hidden="true">check</span>
          <span>Salva</span>
        </button>
      </div>
    </footer>
    </form>
  </div>
</div>

<!-- Modale per i dettagli della seconda chiamata -->
<div class="modal contacts-mobile-modal modal-new-info" v-if="showModalSecond">
  <div class="modal-content contacts-mobile-modal__panel staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-labelledby="staff-contact-second-call-title">
    <header class="staff-editor-header">
      <span class="material-icons staff-editor-heading-icon" aria-hidden="true">description</span>
      <div>
        <h2 id="staff-contact-second-call-title">Dettagli 2ª chiamata</h2>
        <p>Riepilogo del contatto, indicazioni e note della seconda chiamata.</p>
      </div>
      <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi finestra" @click="closeModalSecond">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>
    <form class="staff-editor-form" @submit.prevent="saveSecondCall">
      <div class="staff-editor-body">
        <fieldset class="staff-editor-section">
          <legend>Riepilogo contatto</legend>
          <div class="staff-editor-grid staff-editor-grid--two staff-contact-readonly">
            <p><strong>Nome:</strong> {{ currentContact.name }}</p>
            <p><strong>Email:</strong> {{ currentContact.email }}</p>
            <p><strong>Città:</strong> {{ currentContact.citta }}</p>
            <p><strong>Età:</strong> {{ currentContact.eta }}</p>
            <p><strong>Esperienza allenamento:</strong> {{ currentContact.trainingExperience }}</p>
            <p><strong>Patologie:</strong> {{ currentContact.pathologie }}</p>
            <p><strong>Cognome:</strong> {{ currentContact.surname }}</p>
            <p><strong>Telefono:</strong> {{ currentContact.telefono }}</p>
            <p><strong>Regione:</strong> {{ currentContact.telefono }}</p>
            <p><strong>Obiettivi:</strong> {{ currentContact.objectives }}</p>
            <p><strong>In quanto tempo pensi di ottenere il risultato di cui mi parli?:</strong> {{ currentContact.resultTime }}</p>
            <p><strong>Consigliato nella prima chiamata:</strong> {{ currentContact.consiglio }}</p>
          </div>
        </fieldset>
      <fieldset class="staff-editor-section">
        <legend>Seconda chiamata</legend>
        <div class="staff-editor-grid staff-editor-grid--two">
          <label class="staff-editor-field" for="contacts-modal-field-19">
            <span>Consigliato dalla consulente</span>
            <textarea id="contacts-modal-field-19"
                    v-model="currentContact.consiglio2"
                    rows="3"
                    placeholder="Consiglio 2ª chiamata"
                  ></textarea>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-20">
            <span>Note chiamata</span>
            <textarea id="contacts-modal-field-20"
                    v-model="currentContact.notecontatto2"
                    rows="3"
                    placeholder="Note 2ª chiamata"
                  ></textarea>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-21">
            <span>Esito della chiamata</span>
            <select id="contacts-modal-field-21"
              v-model="currentContact.stato3"
              @change="updateContactField(currentContact, 'stato3')"
            >
                  <option value="">Seleziona uno stato</option>
                  <option value="da ricontattare">Da ricontattare</option>
                  <option value="chiamare a settembre">Chiamare a settembre</option>
                  <option value="fissato app in studio">Fissato App in studio</option>
                  <option value="telefonata riprogrammata">Telefonata Riprogrammata</option>
                  <option value="mai risposto">Mai risposto</option>
                  <option value="In Attesa di finalizzazione">In Attesa di Finalizzazione</option>
                  <option value="non risponde">Non risponde</option>
                  <option value="non interessata">Non interessata</option>
            </select>
          </label>
          <label class="staff-editor-field" for="contacts-modal-field-22">
            <span>Operatore chiamata</span>
            <select id="contacts-modal-field-22"
              v-model="currentContact.operatore3"
              @change="updateContactField(currentContact, 'operatore3')"
            >
                  <option value="">Seleziona un operatore</option>
                  <option value="alessandro">Alessandro</option>
                  <option value="alessiofantini">Alessio Fantini</option>
                  <option value="Gaetano">Gaetano</option>
                  <option value="Luca">Luca Corbella</option>
                  <option value="Paolomarchini">Paolo Marchini</option>
                  <option value="Paoloramunno">Paolo Ramunno</option>
                  <option value="pasquale">Pasquale</option>
                  <option value="mirko">Mirko</option>
                  <option value="Roberta">Roberta</option>
                  <option value="Salvatore">Salvatore</option>


                </select>
          </label>
        </div>
      </fieldset>
      </div>
    <footer class="staff-editor-footer">
      <p>Salva per completare le informazioni della seconda chiamata.</p>
      <div class="staff-editor-actions">
        <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeModalSecond">Annulla</button>
        <button type="submit" class="staff-editor-button staff-editor-save staff-button-positive">
          <span class="material-icons" aria-hidden="true">check</span>
          <span>Salva 2ª chiamata</span>
        </button>
      </div>
    </footer>
    </form>
  </div>
</div>

  <div class="modal contacts-mobile-modal" v-if="showModal">
    <div class="modal-content contacts-mobile-modal__panel staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-label="Crea Nuovo Contatto">
      <header class="staff-editor-header">
        <span class="material-icons staff-editor-heading-icon" aria-hidden="true">person_add</span>
        <div>
          <h2>Crea nuovo contatto</h2>
          <p>Anagrafica e provenienza del contatto.</p>
        </div>
        <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi finestra" @click="closeModal">
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </header>
      <form class="staff-editor-form" @submit.prevent="saveNewContact">
        <div class="staff-editor-body">
          <fieldset class="staff-editor-section">
            <legend>Dati del contatto</legend>
            <div class="staff-editor-grid staff-editor-grid--two">
            <label class="staff-editor-field">
              <span>Nome *</span>
              <input type="text" v-model="newContact.name" aria-label="Nome" placeholder="Nome" required />
            </label>
            <label class="staff-editor-field">
              <span>Cognome</span>
              <input type="text" v-model="newContact.surname" aria-label="Cognome" placeholder="Cognome" />
            </label>
            <label class="staff-editor-field">
              <span>Email</span>
              <input type="text" v-model="newContact.email" aria-label="Email" placeholder="Email" />
            </label>
            <label class="staff-editor-field">
              <span>Telefono *</span>
              <input type="text" v-model="newContact.telefono" aria-label="Telefono" placeholder="Telefono" required />
            </label>
            <label class="staff-editor-field staff-editor-field--wide">
              <span>Fonte del contatto *</span>
              <select v-model="newContact.contattopreso" aria-label="Fonte del contatto" required>
            <option disabled value="">Da dove abbiamo preso il contatto</option>
            <option value="Sponsorizzata">Sponsorizzata</option>
            <option value="Facebook">Facebook</option>
            <option value="Instagram">Instagram</option>
            <option value="Info sito">Info Sito</option>
            <option value="Passapoarola">Passaparola</option>
                      <option value="Ex cliente">Ex Cliente</option>
            <option value="Telefono">Telefono</option>
            <option value="Whatsapp">Whatsapp</option>
            <option value="Email">Email</option>
          </select>
            </label>
            </div>
          </fieldset>
        </div>
        <footer class="staff-editor-footer">
          <p>I campi con * sono obbligatori.</p>
          <div class="staff-editor-actions">
            <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeModal">Annulla</button>
            <button class="staff-editor-button staff-editor-save staff-button-positive" type="submit">
              <span class="material-icons" aria-hidden="true">check</span>
              <span>Salva contatto</span>
            </button>
          </div>
        </footer>
      </form>
    </div>
  </div>

<!-- Template (modal multi-contatti) -->
<div class="modal contacts-mobile-modal" v-if="showModal2">
  <div class="modal-content contacts-mobile-modal__panel staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-label="Crea multi Contatto">
      <header class="staff-editor-header">
        <span class="material-icons staff-editor-heading-icon" aria-hidden="true">group_add</span>
        <div>
          <h2>Crea più contatti</h2>
          <p>Incolla i dati e scegli la fonte dei contatti.</p>
        </div>
        <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi finestra" @click="closeModal">
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </header>
    <div class="staff-editor-form">
      <div class="staff-editor-body">
        <fieldset class="staff-editor-section">
          <legend>Contatti da aggiungere</legend>
          <div class="staff-editor-grid staff-editor-grid--two">
            <label class="staff-editor-field staff-editor-field--wide">
              <span>Dati dei contatti</span>
              <textarea
      v-model="pastedData" aria-label="Dati dei contatti da incollare"
      placeholder="Incolla qui i dati...Nome Cognome Telefono"
      class="search-bar"
    ></textarea>
            </label>
            <label class="staff-editor-field staff-editor-field--wide">
              <span>Fonte del contatto</span>
              <select id="contacts-modal-field-23" v-model="selectedContattopreso" class="search-bar">
        <option value="Sponsorizzata">Sponsorizzata</option>
        <option value="Facebook">Facebook</option>
        <option value="Instagram">Instagram</option>
        <option value="Info sito">Info Sito</option>
        <option value="Passaparola">Passaparola</option>
        <option value="Ex cliente">Ex Cliente</option>
      </select>
            </label>
          </div>
        </fieldset>
      </div>
      <footer class="staff-editor-footer">
        <p>Controlla i dati prima di copiare i contatti.</p>
        <div class="staff-editor-actions">
          <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeModal">Annulla</button>
          <button type="button" @click="handlePasteData" class="create-reset-button staff-editor-button staff-editor-save staff-button-positive">
            <span class="material-icons" aria-hidden="true">group_add</span>
            <span>Copia contatti</span>
          </button>
        </div>
      </footer>
    </div>
  </div>
</div>

<div class="modal contacts-mobile-modal csv-import-modal" v-if="showCsvImportModal">
  <div class="modal-content contacts-mobile-modal__panel csv-import-modal__content staff-editor-dialog staff-contact-dialog staff-contact-dialog--wide" role="dialog" aria-modal="true" aria-labelledby="contacts-csv-title" aria-describedby="contacts-csv-description">
    <header class="staff-editor-header">
      <span class="material-icons staff-editor-heading-icon" aria-hidden="true">upload_file</span>
      <div>
        <h2 id="contacts-csv-title">Contatti CSV</h2>
        <p id="contacts-csv-description">Consulta l'archivio CSV e aggiungi i contatti che servono alla lista principale.</p>
      </div>
      <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi archivio CSV" title="Chiudi archivio CSV" @click="closeModal">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>
    <div class="staff-editor-form">
      <div class="staff-editor-body">
    <div class="csv-import-dashboard">
      <div class="csv-import-dashboard__card">
        <span>Archivio</span>
        <strong>{{ csvStoredContacts.length }}</strong>
      </div>
      <div class="csv-import-dashboard__card">
        <span>Visibili</span>
        <strong>{{ csvFilteredCount }}</strong>
      </div>
      <div class="csv-import-dashboard__card">
        <span>Creati</span>
        <strong>{{ csvCreatedCount }}</strong>
      </div>
      <div class="csv-import-dashboard__card">
        <span>Già in contatti</span>
        <strong>{{ csvExistingCount }}</strong>
      </div>
    </div>

    <fieldset class="staff-editor-section">
      <legend>Importazione CSV</legend>
      <button
        type="button"
        class="csv-import-accordion__toggle"
        :aria-expanded="isCsvImportAccordionOpen"
        aria-controls="contacts-csv-import-panel"
        @click="toggleCsvImportAccordion"
      >
        <span class="material-icons">
          {{ isCsvImportAccordionOpen ? 'expand_less' : 'upload_file' }}
        </span>
        {{ isCsvImportAccordionOpen ? 'Chiudi importazione' : 'Apri importazione CSV' }}
      </button>
    <div class="csv-import-accordion">
      <div
        id="contacts-csv-import-panel"
        class="csv-import-accordion__panel"
        v-if="isCsvImportAccordionOpen"
      >
        <div class="csv-import-modal__controls staff-editor-grid staff-editor-grid--two">
          <label class="csv-import-modal__file staff-editor-field">
            <span>Carica file CSV</span>
            <input type="file" accept=".csv,text/csv" @change="handleCsvFileChange" />
          </label>

          <label class="csv-import-modal__source staff-editor-field">
            <span>Fonte contatto</span>
            <select v-model="csvImportSource" class="search-bar">
              <option value="Import CSV">Import CSV</option>
              <option value="Sponsorizzata">Sponsorizzata</option>
              <option value="Facebook">Facebook</option>
              <option value="Instagram">Instagram</option>
              <option value="Info sito">Info Sito</option>
              <option value="Passaparola">Passaparola</option>
              <option value="Ex cliente">Ex Cliente</option>
              <option value="Telefono">Telefono</option>
              <option value="Whatsapp">Whatsapp</option>
              <option value="Email">Email</option>
            </select>
          </label>
        </div>

        <label class="staff-editor-field staff-editor-field--wide">
          <span>Contenuto CSV</span>
        <textarea
          v-model="csvImportText" aria-label="Contenuto del file CSV"
          class="search-bar csv-import-modal__textarea"
          placeholder="id;name;lastname;fiscal_code;email;carrier_mobile;mobile;phone"
        ></textarea>
        </label>

        <div v-if="csvImportText" class="csv-import-summary">
          <div class="csv-import-summary__item">
            <strong>{{ csvPreviewResult.rows.length }}</strong>
            <span>contatti validi</span>
          </div>
          <div class="csv-import-summary__item">
            <strong>{{ csvPreviewResult.skipped.length }}</strong>
            <span>righe saltate</span>
          </div>
          <div class="csv-import-summary__item">
            <strong>{{ csvPreviewResult.missingHeaders.length }}</strong>
            <span>header mancanti</span>
          </div>
        </div>

        <div
          v-if="csvPreviewResult.missingHeaders.length"
          class="csv-import-warning"
        >
          Header non trovati nel CSV: {{ csvPreviewResult.missingHeaders.join(', ') }}
        </div>

        <div
          v-if="csvPreviewResult.skipped.length"
          class="csv-import-warning csv-import-warning--light"
        >
          Alcune righe non hanno email o telefono e verranno saltate.
        </div>

        <div v-if="csvImportText" class="csv-import-actions csv-import-actions--upload">
          <span class="csv-import-meta">
            I contatti validi dell'anteprima saranno aggiunti all'archivio CSV.
          </span>
          <button
            type="button"
            class="create-reset-button"
            :disabled="!csvPreviewResult.rows.length || isCsvArchiveSaving"
            @click="saveCsvContactsToArchive"
          >
            {{ isCsvArchiveSaving ? 'Salvataggio...' : 'Importa nell’archivio' }}
          </button>
        </div>
      </div>
    </div>

    </fieldset>

    <fieldset class="staff-editor-section">
      <legend>Consultazione archivio</legend>
    <div class="csv-archive-toolbar">
      <div class="csv-archive-toolbar__main">
        <div class="csv-archive-toolbar__header">
          <p class="csv-import-meta">
            Cerca nell'archivio con i filtri e crea i contatti nella lista principale.
          </p>
        </div>
        <div
          v-if="csvActiveFilters.length"
          class="csv-active-filters"
        >
          <span
            v-for="filter in csvActiveFilters"
            :key="filter.key"
            class="csv-active-filter"
          >
            <strong>{{ filter.label }}:</strong> {{ filter.value }}
          </span>
        </div>
      </div>
      <div class="csv-archive-toolbar__actions">
        <button
          type="button"
          class="csv-filter-trigger"
          :aria-expanded="showCsvFiltersModal"
          aria-haspopup="dialog"
          @click="toggleCsvFiltersModal"
        >
          <span class="material-icons">tune</span>
          Filtri
          <span
            v-if="csvActiveFiltersCount"
            class="csv-filter-trigger__count"
          >
            {{ csvActiveFiltersCount }}
          </span>
        </button>
      </div>
    </div>

    <div v-if="isCsvArchiveLoading" class="csv-import-empty">
      Caricamento archivio CSV...
    </div>

    <div v-else-if="filteredCsvStoredContacts.length" class="csv-import-table-wrap">
      <table class="csv-import-table">
        <thead>
          <tr>
            <th>Azioni</th>
            <th>Stato</th>
            <th>ID CSV</th>
            <th>Nome</th>
            <th>Cognome</th>
            <th>Email</th>
            <th>Telefono</th>
            <th>Secondario</th>
            <th>Cod. fiscale</th>
            <th>Importato il</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="contact in csvPaginatedContacts"
            :key="contact.uid"
            :class="{ 'csv-import-table__row--existing': isCsvContactExisting(contact) }"
          >
            <td class="csv-import-table__actions">
              <span
                v-if="isCsvContactExisting(contact)"
                class="csv-row-indicator csv-row-indicator--existing"
                title="Contatto gia presente nella lista principale"
                aria-label="Contatto gia presente nella lista principale"
              >
                <span class="material-icons">person_search</span>
              </span>
              <button
                type="button"
                class="csv-create-row-button"
                :disabled="!canCreateCsvContact(contact)"
                @click="createCsvContactRow(contact)"
              >
                {{ csvContactActionLabel(contact) }}
              </button>
              <button
                type="button"
                class="csv-delete-row-button"
                :disabled="isCsvContactDeleting(contact)"
                @click="deleteStoredCsvContact(contact)"
                title="Elimina contatto CSV"
                aria-label="Elimina contatto CSV"
              >
                <span class="material-icons">delete</span>
              </button>
            </td>
            <td>
              <span
                class="csv-status-badge"
                :class="csvContactStatusClass(contact)"
              >
                <span class="material-icons" aria-hidden="true">
                  {{ csvContactStatusIcon(contact) }}
                </span>
                {{ csvContactStatusLabel(contact) }}
              </span>
            </td>
            <td>{{ contact.csvId || '—' }}</td>
            <td>{{ contact.name || '—' }}</td>
            <td>{{ contact.surname || '—' }}</td>
            <td>{{ contact.email || '—' }}</td>
            <td>{{ contact.telefono || '—' }}</td>
            <td>{{ contact.telefonoSecondario || '—' }}</td>
            <td>{{ contact.codiceFiscale || '—' }}</td>
            <td>{{ formatDate(contact.created_time) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-if="filteredCsvStoredContacts.length"
      class="csv-pagination"
    >
      <div class="csv-pagination__summary">
        <strong>{{ csvPageStart }}-{{ csvPageEnd }}</strong>
        <span>di {{ csvFilteredCount }} contatti filtrati</span>
      </div>
      <div class="csv-pagination__controls">
        <button
          type="button"
          class="csv-pagination__button"
          :disabled="csvCurrentPage === 1"
          @click="goToCsvPage(1)"
        >
          Prima
        </button>
        <button
          type="button"
          class="csv-pagination__button"
          :disabled="csvCurrentPage === 1"
          aria-label="Pagina CSV precedente"
          @click="goToPreviousCsvPage"
        >
          <span class="material-icons">chevron_left</span>
        </button>

        <button
          v-for="page in csvVisiblePageNumbers"
          :key="`csv-page-${page}`"
          type="button"
          class="csv-pagination__button"
          :class="{ 'csv-pagination__button--active': page === csvCurrentPage }"
          :aria-current="page === csvCurrentPage ? 'page' : undefined"
          @click="goToCsvPage(page)"
        >
          {{ page }}
        </button>

        <button
          type="button"
          class="csv-pagination__button"
          :disabled="csvCurrentPage === csvTotalPages"
          aria-label="Pagina CSV successiva"
          @click="goToNextCsvPage"
        >
          <span class="material-icons">chevron_right</span>
        </button>
        <button
          type="button"
          class="csv-pagination__button"
          :disabled="csvCurrentPage === csvTotalPages"
          @click="goToCsvPage(csvTotalPages)"
        >
          Ultima
        </button>
      </div>
    </div>

    <div v-else class="csv-import-empty">
      Nessun contatto CSV salvato per i filtri correnti.
    </div>

    </fieldset>
      </div>
      <footer class="csv-import-actions staff-editor-footer">
        <p class="csv-import-meta">
          Archivio: {{ csvStoredContacts.length }} · Creati: {{ csvCreatedCount }} · Già presenti: {{ csvExistingCount }}
        </p>
        <div class="staff-editor-actions">
          <button type="button" class="staff-editor-button staff-button-neutral" @click="closeModal">Chiudi</button>
        </div>
      </footer>
    </div>
  </div>
    <div
      v-if="showCsvFiltersModal"
      class="csv-filters-modal contacts-mobile-modal"
      @click.self="closeCsvFiltersModal"
    >
      <div class="csv-filters-modal__content contacts-mobile-modal__panel staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-labelledby="contacts-csv-filters-title" aria-describedby="contacts-csv-filters-description" @click.stop>
        <header class="csv-filters-modal__header staff-editor-header">
          <span class="material-icons staff-editor-heading-icon" aria-hidden="true">tune</span>
          <div>
            <h2 id="contacts-csv-filters-title">Ricerca contatti CSV</h2>
            <p id="contacts-csv-filters-description">Filtra l'archivio per cognome, email o telefono.</p>
          </div>
          <button type="button" class="csv-filters-modal__close staff-editor-close staff-button-neutral" aria-label="Chiudi filtri CSV" title="Chiudi filtri CSV" @click="closeCsvFiltersModal">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </header>
        <div class="staff-editor-form">
          <div class="staff-editor-body">
            <fieldset class="staff-editor-section">
              <legend>Ricerca</legend>
        <div class="csv-filters-modal__grid staff-editor-grid staff-editor-grid--three">
          <label class="csv-archive-search staff-editor-field">
            <span>Cognome</span>
            <input
              v-model="csvSearchSurname"
              type="text"
              class="search-bar"
              placeholder="Es. Rossi"
            />
          </label>
          <label class="csv-archive-search staff-editor-field">
            <span>Email</span>
            <input
              v-model="csvSearchEmail"
              type="text"
              class="search-bar"
              placeholder="Es. nome@email.it"
            />
          </label>
          <label class="csv-archive-search staff-editor-field">
            <span>Telefono</span>
            <input
              v-model="csvSearchPhone"
              type="text"
              class="search-bar"
              placeholder="Es. 3331234567"
            />
          </label>
        </div>

            </fieldset>
          </div>
          <footer class="staff-editor-footer">
            <p>I risultati si aggiornano mentre scrivi.</p>
        <div class="csv-filters-modal__actions staff-editor-actions">
          <button
            type="button"
            class="csv-filter-reset staff-editor-button staff-button-neutral"
            :disabled="!csvHasActiveSearch"
            @click="resetCsvSearchFilters"
          >
            <span class="material-icons">restart_alt</span>
            Reset
          </button>
          <button
            type="button"
            class="csv-filters-modal__apply staff-editor-button staff-button-neutral"
            @click="closeCsvFiltersModal"
          >
            Chiudi
          </button>
        </div>
          </footer>
        </div>
      </div>
    </div>
</div>


  <div class="modal contacts-mobile-modal" v-if="showModal3">
    <div class="modal-content contacts-mobile-modal__panel staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-label="Crea filtri Contatto">
      <header class="staff-editor-header">
        <span class="material-icons staff-editor-heading-icon" aria-hidden="true">tune</span>
        <div>
          <h2>Filtri contatti</h2>
          <p>Affina la lista per stato, provenienza e acquisti.</p>
        </div>
        <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi finestra" @click="closeModal">
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </header>
      <div class="staff-editor-form">
        <div class="staff-editor-body">
          <fieldset class="staff-editor-section">
            <legend>Contatto e gestione</legend>
            <div class="staff-editor-grid staff-editor-grid--two">
            <label class="staff-editor-field">
              <span>Stato del contatto</span>
              <select v-model="filterByState" aria-label="Stato del contatto">
        <option value="">Seleziona Stato</option>
        <option value="no_selection">Nessun elemento</option>
        <option value="inviato messaggio">Inviato messaggio WA</option>
        <option value="appuntamento telefonico">Appuntamento Telefonico</option>
        <option value="appuntamento studio">Appuntamento studio</option>
        <option value="interessato online">Interessato online</option>
        <option value="interessato ma non al momento">Interessato ma non al momento</option>
                  <option value="gia attiva">Già attiva</option>

        <option value="da ricontattare">Da ricontattare</option>
        <option value="chiamare a settembre">Chiamare a settembre</option>
        <option value="mai risposto">Mai risposto</option>
        <option value="ghosting">Ghosting</option>
        <option value="non risponde">Non risponde</option>
        <option value="non interessata">Non interessata</option>
      </select>
            </label>
            <label class="staff-editor-field">
              <span>Fonte del contatto</span>
              <select v-model="filterByContattoPreso" aria-label="Fonte del contatto">
        <option value="">Seleziona da dove arriva il contatto</option>
            <option value="Sponsorizzata">Sponsorizzata</option>
<option value="wp_popup">Pop up sito</option>
            <option value="protocolloTop">Protocollo Top</option>
            <option value="refInfluencer">Influencer</option>
            <option value="Import CSV">Import CSV</option>
            <option value="Facebook">Facebook</option>
            <option value="Instagram">Instagram</option>
            <option value="Info sito">Info Sito</option>
            <option value="Passapoarola">Passaparola</option>
                      <option value="Ex cliente">Ex Cliente</option>
            <option value="Telefono">Telefono</option>
            <option value="Whatsapp">Whatsapp</option>
            <option value="Email">Email</option>
      </select>
            </label>
            <label class="staff-editor-field">
              <span>Contatto lavorato</span>
              <select v-model="filterByLavorato" aria-label="Contatto lavorato">
  <option value="">Lavorato?</option>
  <option value="true">Sì</option>
  <option value="false">No</option>
</select>
            </label>
            <label class="staff-editor-field">
              <span>Operatore</span>
              <select id="contacts-filter-operator" v-model="filterByOperator" aria-label="Operatore">
        <option value="alessandro">Alessandro</option>
        <option value="alessiofantini">Alessio Fantini</option>
        <option value="Gaetano">Gaetano</option>
        <option value="Luca">Luca Corbella</option>
        <option value="Paolomarchini">Paolo Marchini</option>
        <option value="Paoloramunno">Paolo Ramunno</option>
        <option value="pasquale">Pasquale</option>
        <option value="mirko">Mirko</option>
        <option value="Roberta">Roberta</option>
        <option value="Salvatore">Salvatore</option>
      </select>
            </label>
            <label class="staff-editor-field staff-editor-field--wide">
              <span>Studio</span>
              <select v-model="filterByStudio" aria-label="Studio">
        <option value="">Seleziona lo studio</option>
        <option value="Tivoli Quartier generale">Tivoli Quartier generale</option>
        <option value="FF Genova">FF Genova</option>
        <option value="FF Bologna">FF Bologna</option>
        <option value="FF Bari">FF Bari</option>
        <option value="FF Pescara">FF Pescara</option>
        <option value="FF Firenze">FF Firenze</option>
        <option value="FF Torino">FF Torino</option>
        <option value="FF Napoli">FF Napoli</option>
        <option value="FF Milano">FF Milano</option>
        <option value="FF Milano Sempione">FF Milano Sempione</option>
        <option value="FF Milano Citta Studi">FF Milano Città Studi</option>
        <option value="FF Roma">FF Roma</option>
        <option value="FF Roma Eur">FF Roma Eur</option>
        <option value="FF Salerno">FF Salerno</option>
        <option value="FF Cagliari">FF Cagliari</option>
        <option value="FF Padova">FF Padova</option>
      </select>
            </label>
            </div>
          </fieldset>
          <fieldset class="staff-editor-section">
            <legend>Acquisti</legend>
            <div class="staff-editor-grid staff-editor-grid--two">
              <div class="acquistato-filter staff-editor-field staff-editor-field--wide">
                <span>Stato acquisto</span>
                <div class="search-field-row staff-contact-check-options">
                  <label class="lavorato-cell">
                    <input type="checkbox" v-model="filterByAcquistato" />
                    <span>{{ filterByAcquistato ? 'Solo acquistati' : 'Tutti' }}</span>
                  </label>
                  <label class="lavorato-cell">
                    <input type="checkbox" v-model="filterByNonAcquistato" />
                    <span>Non acquistato</span>
                  </label>
                </div>
              </div>
            <label class="staff-editor-field">
              <span>Data acquisto: dal</span>
              <input type="date" v-model="startAcquisto" aria-label="Data iniziale di acquisto" class="search-bar">
            </label>
            <label class="staff-editor-field">
              <span>Data acquisto: al</span>
              <input type="date" v-model="endAcquisto" aria-label="Data finale di acquisto" class="search-bar">
            </label>
            </div>
          </fieldset>
        </div>
        <footer class="staff-editor-footer">
          <p>I filtri si applicano automaticamente alla lista.</p>
          <div class="staff-editor-actions">
            <button type="button" @click="resetFilters" class="create-reset-button staff-editor-button staff-button-neutral">Reset filtri</button>
            <button type="button" class="staff-editor-button staff-button-neutral" @click="closeModal">Chiudi</button>
          </div>
        </footer>
      </div>
    </div>
  </div>

  <div class="modal contacts-mobile-modal" v-if="showModal4">
    <div class="modal-content contacts-mobile-modal__panel staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-label="Statistiche Contatti">
      <header class="staff-editor-header">
        <span class="material-icons staff-editor-heading-icon" aria-hidden="true">bar_chart</span>
        <div>
          <h2>Statistiche contatti</h2>
          <p>Una panoramica dei contatti e delle risposte.</p>
        </div>
        <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi finestra" @click="closeModal">
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </header>
      <div class="staff-editor-form">
        <div class="staff-editor-body">
          <fieldset class="staff-editor-section">
            <legend>Panoramica</legend>
            <dl class="staff-contact-stats">
              <div><dt>Contatti totali</dt><dd>{{ totalContacts }}</dd></div>
              <div><dt>Non risponde</dt><dd>{{ nonRispondeCount }}</dd></div>
              <div><dt>Da ricontattare</dt><dd>{{ daRicontattareCount }}</dd></div>
            </dl>
          </fieldset>
        </div>
        <footer class="staff-editor-footer">
          <div class="staff-editor-actions">
            <button type="button" class="staff-editor-button staff-button-neutral" @click="closeModal">Chiudi</button>
          </div>
        </footer>
      </div>
    </div>
  </div>

  <div
    class="modal contacts-mobile-modal note-editor-modal"
    v-if="showNoteModal"
    @click.self="closeNoteEditor"
  >
    <div class="modal-content contacts-mobile-modal__panel note-editor-modal__content staff-editor-dialog staff-contact-dialog" role="dialog" aria-modal="true" aria-label="Nota contatto" @click.stop>
      <header class="staff-editor-header">
        <span class="material-icons staff-editor-heading-icon" aria-hidden="true">description</span>
        <div>
          <h2>Nota contatto</h2>
          <p>Leggi o aggiorna le informazioni del contatto.</p>
        </div>
        <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi finestra" @click="closeNoteEditor">
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </header>
      <div class="staff-editor-form">
        <div class="staff-editor-body">
          <div v-if="noteEditorContact" class="note-editor-modal__meta">
            <span class="note-editor-modal__name">{{ noteEditorContact.name || 'Senza nome' }}</span>
            <span
              v-if="noteEditorContact.surname"
              class="note-editor-modal__surname"
            >{{ noteEditorContact.surname }}</span>
          </div>
          <fieldset class="staff-editor-section">
            <legend>Note e indicazioni</legend>
            <label class="note-editor-modal__field staff-editor-field">
              <span>Nota</span>
              <textarea
                v-model="noteEditorValue" aria-label="Nota del contatto"
                class="note-editor-modal__textarea"
                rows="6"
                placeholder="Scrivi o aggiorna la nota"
              ></textarea>
            </label>
          </fieldset>
        </div>
        <footer class="staff-editor-footer">
          <p>Le modifiche si applicano con Salva.</p>
          <div class="note-editor-modal__actions staff-editor-actions">
            <button type="button" class="note-modal-btn note-modal-btn--ghost staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeNoteEditor">
              Annulla
            </button>
            <button type="button" class="note-modal-btn note-modal-btn--primary staff-editor-button staff-editor-save staff-button-positive" @click="saveNoteEditor">
              <span class="material-icons" aria-hidden="true">check</span>
              <span>Salva</span>
            </button>
          </div>
        </footer>
      </div>
    </div>
  </div>

</template>
<script>
/* eslint-disable no-console */
import { ref, onMounted, computed, watch, onUnmounted, nextTick, reactive } from 'vue';
import { useRoute } from 'vue-router';
import notificationSound from '../../assets/notification.mp3';
import {
  getFirestore, collection, getDocs, query, orderBy, updateDoc, doc, addDoc,
  where, Timestamp, writeBatch, deleteDoc, getDoc, deleteField
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import SidebarComponent from '../SidebarComponent.vue';

const CALENDAR_STATUS_OPTIONS = Object.freeze([
  { value: 'da_confermare', label: 'Da confermare', color: '#f59e0b', icon: 'hourglass_empty' },
  { value: 'da_riprogrammare', label: 'Da riprogrammare', color: '#db2777', icon: 'autorenew' },
  { value: 'confermato', label: 'Confermato', color: '#2563eb', icon: 'done' },
  { value: 'fatto', label: 'Fatto', color: '#16a34a', icon: 'check_circle' },
]);

const CALENDAR_STATUS_FIELDS = new Set(['calendarStatus2', 'calendarStatus3']);
const CALENDAR_STATUS_VALUES = new Set(CALENDAR_STATUS_OPTIONS.map(option => option.value));

export default {
  components: { SidebarComponent },
  setup() {
    // eslint-disable-next-line no-unused-vars
    const userRole = ref(localStorage.getItem('userRole') || '');

    let reminderAudio = null;
    let agendaReloadPending = false;
    let reminderHideTimer = null;
    if (typeof window !== 'undefined') {
      reminderAudio = new Audio(notificationSound);
      reminderAudio.preload = 'auto';
    }

    const reminderTimeouts = new Set();

    const db = getFirestore();
    const csvContactsCollection = 'contattiCsv';
    const auth = getAuth();
    const route = useRoute();

    const highlightedContactId = ref(route.query.contactId ? String(route.query.contactId) : null);

    const filterByLavorato = ref(''); // '', 'true', 'false'


    const contacts = ref([]);
    const cache = ref([]);
    const acquistoContacts = ref([]);
    const agendaContacts = ref([]);
    const calendarStatusUpdateLocks = ref(new Set());
    const isAgendaLoading = ref(false);
    const remindersQueue = ref([]);
    const activeReminder = ref(null);
    const reminderVisible = ref(false);

    // time options 08:00–21:00 ogni 15'
    const timeOptions = [];
    for (let h = 8; h <= 21; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hh = String(h).padStart(2, '0');
        const mm = String(m).padStart(2, '0');
        timeOptions.push(`${hh}:${mm}`);
      }
    }

    const showModal = ref(false);
    const showModal2 = ref(false);
    const showCsvImportModal = ref(false);
    const showModal3 = ref(false);
    const showModal4 = ref(false);
    const showModal5 = ref(false);
    const showModalSecond = ref(false);
    const showCalendarView = ref(false);
    const showNoteModal = ref(false);
    const showReminderModal = ref(false);
    const reminderModalContact = ref(null);
    const reminderForm = reactive({
      dueAt: '',
      note: '',
      consultantName: '',
      consultantEmail: '',
    });
    const isSavingReminder = ref(false);
    const currentContact = ref(null);
    const noteEditorContact = ref(null);
    const noteEditorValue = ref('');

    const isLoading = ref(false);
    const isAccordionOpen = ref(false);
    const expandedMobileContactIds = ref(new Set());
    const isMobileContactExpanded = (contact) => expandedMobileContactIds.value.has(contact.uid || contact.id);
    const toggleMobileContactDetails = (contact) => {
      const contactId = contact.uid || contact.id;
      if (expandedMobileContactIds.value.has(contactId)) {
        expandedMobileContactIds.value.delete(contactId);
      } else {
        expandedMobileContactIds.value.add(contactId);
      }
    };

    const normalizePhone = (str = '') => String(str).replace(/\D/g, '');
    const stripItalianPrefix = (digits = '') => {
      if (!digits) return '';
      if (digits.startsWith('0039')) return digits.slice(4);
      if (digits.startsWith('39') && digits.length > 10) return digits.slice(2);
      return digits;
    };
    const normalizeContactSource = (value = '') => String(value || '').trim().toLowerCase();
    const userMatchSources = new Set(['wp_popup', 'protocollotop']);
    const buildPhoneVariants = (normalized = '') => {
      if (!normalized) return [];
      const variants = new Set([normalized]);
      variants.add(`39${normalized}`);
      variants.add(`+39${normalized}`);
      variants.add(`0039${normalized}`);
      return Array.from(variants).filter(Boolean);
    };
    const buildPhoneMatchVariants = (value = '') => {
      const normalizedPhone = stripItalianPrefix(normalizePhone(value));
      return buildPhoneVariants(normalizedPhone);
    };
    const normalizeNullableCsvValue = (value = '') => {
      const trimmed = String(value ?? '').replace(/\uFEFF/g, '').trim();
      if (!trimmed) return '';
      return trimmed.toUpperCase() === 'NULL' ? '' : trimmed;
    };
    const normalizeEmail = (value = '') => normalizeNullableCsvValue(value).toLowerCase();
    const splitSemicolonCsvLine = (line = '') => {
      const values = [];
      let current = '';
      let inQuotes = false;

      for (let i = 0; i < line.length; i += 1) {
        const char = line[i];
        if (char === '"') {
          if (inQuotes && line[i + 1] === '"') {
            current += '"';
            i += 1;
          } else {
            inQuotes = !inQuotes;
          }
          continue;
        }

        if (char === ';' && !inQuotes) {
          values.push(current);
          current = '';
          continue;
        }

        current += char;
      }

      values.push(current);
      return values;
    };
    const expectedCsvHeaders = [
      'id',
      'name',
      'lastname',
      'fiscal_code',
      'email',
      'carrier_mobile',
      'mobile',
      'phone',
    ];
    const parseCsvContacts = (rawCsv, sourceLabel) => {
      const text = String(rawCsv || '')
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .trim();

      if (!text) {
        return { rows: [], skipped: [], missingHeaders: [] };
      }

      const lines = text.split('\n').filter(line => line.trim() !== '');
      if (lines.length < 2) {
        return {
          rows: [],
          skipped: [{ lineNumber: 1, reason: 'Nessuna riga dati nel CSV' }],
          missingHeaders: [...expectedCsvHeaders],
        };
      }

      const headers = splitSemicolonCsvLine(lines[0]).map(value => normalizeNullableCsvValue(value).toLowerCase());
      const headerIndex = new Map(headers.map((header, index) => [header, index]));
      const missingHeaders = expectedCsvHeaders.filter(header => !headerIndex.has(header));

      const getColumnValue = (cells, headerName) => {
        const index = headerIndex.get(headerName);
        if (index == null) return '';
        return normalizeNullableCsvValue(cells[index] || '');
      };

      const rows = [];
      const skipped = [];

      lines.slice(1).forEach((line, rowIndex) => {
        const cells = splitSemicolonCsvLine(line);
        const rawMobile = normalizePhone(getColumnValue(cells, 'mobile'));
        const rawPhone = normalizePhone(getColumnValue(cells, 'phone'));
        const primaryPhone = rawMobile || rawPhone;
        const secondaryPhone = rawMobile && rawPhone && rawPhone !== rawMobile ? rawPhone : '';
        const normalizedPhone = stripItalianPrefix(primaryPhone);
        const email = normalizeEmail(getColumnValue(cells, 'email'));

        if (!email && !primaryPhone) {
          skipped.push({
            lineNumber: rowIndex + 2,
            reason: 'Riga senza email e telefono',
          });
          return;
        }

        rows.push({
          csvId: getColumnValue(cells, 'id'),
          name: getColumnValue(cells, 'name'),
          surname: getColumnValue(cells, 'lastname'),
          codiceFiscale: getColumnValue(cells, 'fiscal_code'),
          email,
          telefono: primaryPhone,
          telefonoSecondario: secondaryPhone,
          carrierMobile: getColumnValue(cells, 'carrier_mobile'),
          contattopreso: sourceLabel,
          _lineNumber: rowIndex + 2,
          _normalized: normalizedPhone,
          _variants: Array.from(
            new Set(buildPhoneVariants(normalizedPhone).concat(primaryPhone ? [primaryPhone] : []))
          ),
        });
      });

      return { rows, skipped, missingHeaders };
    };
    const hydrateStoredCsvContact = (contact, uid = contact?.uid) => {
      const email = normalizeEmail(contact?.email || '');
      const telefono = normalizePhone(contact?.telefono || '');
      const telefonoSecondario = normalizePhone(contact?.telefonoSecondario || '');
      const normalizedPhone = stripItalianPrefix(telefono);
      return {
        ...contact,
        uid,
        email,
        telefono,
        telefonoSecondario,
        _normalized: normalizedPhone,
        _variants: Array.from(
          new Set(buildPhoneVariants(normalizedPhone).concat(telefono ? [telefono] : []))
        ),
      };
    };

    const getUserProfileLink = (c) => {
      if (!c || !c._matchedUserUid) return null;
      return `#/user/${c._matchedUserUid}/anagrafica`;
    };

function matchStrengthOf(c) {
  const s = (c && c._matchStrength) ? c._matchStrength : 'none';
  return s; // 'strong' | 'email' | 'phone' | 'none'
}

function matchTitle(c) {
  const s = matchStrengthOf(c);
  switch (s) {
    case 'strong': return 'Match: email + telefono';
    case 'email':  return 'Match: email';
    case 'phone':  return 'Match: telefono';
    default:       return 'Nessun match';
  }
}

function isFromPopup(c) {
  return normalizeContactSource(c?.contattopreso) === 'wp_popup';
}

function isUserMatchSource(c) {
  return userMatchSources.has(normalizeContactSource(c?.contattopreso));
}

function getContactNoteValue(contact) {
  return String(contact?.note || contact?.obiettivo || '').trim();
}


const toggleLavorato = async (contact, checked) => {
  try {
    const refDoc = doc(db, 'contatti', contact.uid);
    const payload = {
      lavorato: !!checked,
      lavoratoAt: checked ? Timestamp.now() : null,
    };
    await updateDoc(refDoc, payload);
    contact.lavorato = !!checked;
    contact.lavoratoAt = payload.lavoratoAt;
  } catch (e) {
    console.error('Errore toggle lavorato:', e);
  }
};

const toggleExCliente = async (contact, checked) => {
  try {
    const refDoc = doc(db, 'contatti', contact.uid);
    const payload = {
      excliente: !!checked,
    };
    await updateDoc(refDoc, payload);
    contact.excliente = !!checked;
  } catch (e) {
    console.error('Errore toggle ex cliente:', e);
  }
};

const hasOrderMatch = (contact) => !!(contact && contact._orderMatch);
const getAcquistoDate = (contact) => contact?._orderAcquistatoAt || contact?.acquistatoAt || null;
const getImportoValue = (contact) => {
  const orderTotal = contact?._orderMatch?.totalPrice;
  if (orderTotal !== undefined && orderTotal !== null) return Number(orderTotal);
  return contact?.importo;
};
const orderLink = (contact) => {
  if (!hasOrderMatch(contact)) return null;
  const email =
    (contact?.email || '').trim()
    || (contact?._orderMatch?.userEmail || '').trim()
    || (contact?._orderMatch?.customerEmail || '').trim();
  if (!email) return null;
  return `#/order-list-new?searchEmail=${encodeURIComponent(email)}`;
};
const formatPrice = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  return num.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const isAcquistato = (contact) => {
  if (hasOrderMatch(contact)) return true;
  const value = contact?.acquistato;
  if (value === true) return true;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'si' || normalized === 'sì' || normalized === 'yes';
  }
  return false;
};

const toggleAcquistato = async (contact, checked) => {
  if (hasOrderMatch(contact)) {
    console.warn('Acquisto derivato da ordine: modifica manuale ignorata.');
    return;
  }
  try {
    const refDoc = doc(db, 'contatti', contact.uid);
    const timestamp = checked ? Timestamp.now() : null;
    const payload = {
      acquistato: checked ? 'Si' : 'No',
      acquistatoAt: timestamp,
    };
    await updateDoc(refDoc, payload);
    contact.acquistato = payload.acquistato;
    contact.acquistatoAt = payload.acquistatoAt;
  } catch (error) {
    console.error('Errore toggle acquistato:', error);
  }
};

const isWithinRange = (date, start, end) => {
  if (!date) return false;
  const value = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

  let afterStart = true;
  if (start) {
    const startDate = new Date(start);
    startDate.setHours(0, 0, 0, 0);
    afterStart = value >= startDate.getTime();
  }

  let beforeEnd = true;
  if (end) {
    const endDate = new Date(end);
    endDate.setHours(23, 59, 59, 999);
    beforeEnd = value <= endDate.getTime();
  }

  return afterStart && beforeEnd;
};

// mostra il badge solo per righe provenienti dai form che supportano il match utente
function shouldShowMatchBadge(c) {
  return isUserMatchSource(c);
}


    const chunk = (arr, size = 10) => {
      const out = [];
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    };





    const showDatePicker = ref(null);
    const newContact = ref({
      name: '', surname: '', email: '', contattopreso: '', telefono: '',
    });

    const contactField = ref({
      knownFrom: '', nearStudio: '', objectives: '', serviceExplanation: '',
      trainingExperience: '', pathologies: '', resultTime: '',
      consultantRecommendation: '', generalNotes: '',
    });

    const pastedData = ref('');
    const selectedContattopreso = ref('Sponsorizzata');
    const csvImportText = ref('');
    const csvImportSource = ref('Import CSV');
    const isCsvImportAccordionOpen = ref(false);
    const showCsvFiltersModal = ref(false);
    const csvCurrentPage = ref(1);
    const csvStoredContacts = ref([]);
    const csvSearchEmail = ref('');
    const csvSearchSurname = ref('');
    const csvSearchPhone = ref('');
    const isCsvArchiveLoading = ref(false);
    const isCsvArchiveSaving = ref(false);
    const csvCreatedContactMap = ref({});
    const csvExistingContactMap = ref({});
    const csvCreatingContactMap = ref({});
    const csvDeletingContactMap = ref({});

    const searchEmail = ref(route.query.email ? String(route.query.email).toLowerCase().trim() : '');
    const searchPhone = ref('');
    const searchSurname = ref('');
    const startDate = ref('');
    const endDate = ref('');
    const startDateLavorato = ref('');
    const endDateLavorato = ref('');
    const startDateCall = ref('');
    const endDateCall = ref('');
    const lastAgendaRangeKey = ref('');
    const filterByState = ref('');
    const filterByStudio = ref('');
    const filterByContattoPreso = ref('');
    const filterByOperator = ref('');
    const filterByAcquistato = ref(false);
    const filterByNonAcquistato = ref(false);
    const startAcquisto = ref('');
    const endAcquisto = ref('');
    const csvPreviewResult = computed(() => parseCsvContacts(csvImportText.value, csvImportSource.value));
    const csvContactsPerPage = 50;
    const filteredCsvStoredContacts = computed(() => {
      const emailNeedle = normalizeEmail(csvSearchEmail.value);
      const surnameNeedle = String(csvSearchSurname.value || '').trim().toLowerCase();
      const phoneNeedle = stripItalianPrefix(normalizePhone(csvSearchPhone.value));

      return csvStoredContacts.value.filter(contact => {
        const matchesEmail = !emailNeedle || normalizeEmail(contact.email || '').includes(emailNeedle);
        const matchesSurname = !surnameNeedle || String(contact.surname || '').toLowerCase().includes(surnameNeedle);
        const matchesPhone = !phoneNeedle
          || stripItalianPrefix(normalizePhone(contact.telefono || '')).includes(phoneNeedle)
          || stripItalianPrefix(normalizePhone(contact.telefonoSecondario || '')).includes(phoneNeedle);

        return matchesEmail && matchesSurname && matchesPhone;
      });
    });
    const csvFilteredCount = computed(() => filteredCsvStoredContacts.value.length);
    const csvTotalPages = computed(() =>
      Math.max(1, Math.ceil(filteredCsvStoredContacts.value.length / csvContactsPerPage))
    );
    const csvPaginatedContacts = computed(() => {
      const start = (csvCurrentPage.value - 1) * csvContactsPerPage;
      return filteredCsvStoredContacts.value.slice(start, start + csvContactsPerPage);
    });
    const csvPageStart = computed(() => (
      filteredCsvStoredContacts.value.length
        ? ((csvCurrentPage.value - 1) * csvContactsPerPage) + 1
        : 0
    ));
    const csvPageEnd = computed(() =>
      Math.min(csvCurrentPage.value * csvContactsPerPage, csvFilteredCount.value)
    );
    const csvVisiblePageNumbers = computed(() => {
      const total = csvTotalPages.value;
      const current = csvCurrentPage.value;
      const start = Math.max(1, current - 2);
      const end = Math.min(total, current + 2);
      const pages = [];
      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }
      return pages;
    });
    const csvHasActiveSearch = computed(() =>
      !!(csvSearchEmail.value || csvSearchSurname.value || csvSearchPhone.value)
    );
    const csvActiveFilters = computed(() => {
      const filters = [];
      if (csvSearchSurname.value) {
        filters.push({ key: 'surname', label: 'Cognome', value: csvSearchSurname.value });
      }
      if (csvSearchEmail.value) {
        filters.push({ key: 'email', label: 'Email', value: csvSearchEmail.value });
      }
      if (csvSearchPhone.value) {
        filters.push({ key: 'phone', label: 'Telefono', value: csvSearchPhone.value });
      }
      return filters;
    });
    const csvActiveFiltersCount = computed(() => csvActiveFilters.value.length);
    const csvCreatedCount = computed(() => Object.keys(csvCreatedContactMap.value).length);
    const csvExistingCount = computed(() => Object.keys(csvExistingContactMap.value).length);

    const combinedContacts = computed(() => mergeContactsByUid(contacts.value, acquistoContacts.value));

    const totalContacts = computed(() => combinedContacts.value.length);
    const nonRispondeCount = computed(() =>
      combinedContacts.value.filter(c => c.stato === 'non risponde' || c.stato === 'non interessata').length
    );
    const daRicontattareCount = computed(() =>
      combinedContacts.value.filter(c => c.stato === 'da ricontattare').length
    );

    const sortedContacts = computed(() => {
      return [...combinedContacts.value].sort((a, b) => {
        const ta = a.orario || '00:00';
        const tb = b.orario || '00:00';
        return ta.localeCompare(tb);
      });
    });

    const toJsDate = value => {
      if (!value) return null;
      if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
      }
      if (typeof value.toDate === 'function') {
        const date = value.toDate();
        return Number.isNaN(date.getTime()) ? null : date;
      }
      if (typeof value === 'number') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
      }
      if (typeof value === 'string') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
      }
      if (value.seconds) {
        const date = new Date(value.seconds * 1000);
        return Number.isNaN(date.getTime()) ? null : date;
      }
      return null;
    };

    const buildDateKey = date => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const formatCalendarHeader = date => {
      const label = date.toLocaleDateString('it-IT', {
        weekday: 'long',
        day: '2-digit',
        month: '2-digit',
      });
      return label.charAt(0).toUpperCase() + label.slice(1);
    };

    const timeToMinutes = time => {
      if (!time || typeof time !== 'string') return Number.MAX_SAFE_INTEGER;
      const [hoursPart, minutesPart] = time.split(':');
      const hours = parseInt(hoursPart, 10);
      const minutes = parseInt(minutesPart, 10);
      if (Number.isNaN(hours) || Number.isNaN(minutes)) {
        return Number.MAX_SAFE_INTEGER;
      }
      return hours * 60 + minutes;
    };

    const combineDateAndTime = (dateObj, time) => {
      if (!dateObj || !time || typeof time !== 'string') return null;
      const [hoursStr, minutesStr] = time.split(':');
      const hours = Number(hoursStr);
      const minutes = Number(minutesStr);
      if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
      return new Date(
        dateObj.getFullYear(),
        dateObj.getMonth(),
        dateObj.getDate(),
        hours,
        minutes,
        0,
        0
      );
    };

    function mergeContactsByUid(...lists) {
      const map = new Map();
      lists.forEach(list => {
        list.forEach(item => {
          if (!item) return;
          const key = item.uid || item.id || item.docId;
          if (!key) return;
          if (!map.has(key)) {
            map.set(key, item);
          } else {
            Object.assign(map.get(key), item);
          }
        });
      });
      return Array.from(map.values());
    }

    const clearReminderTimeouts = () => {
      if (typeof window === 'undefined') return;
      reminderTimeouts.forEach(id => clearTimeout(id));
      reminderTimeouts.clear();
    };

    const normalizeDay = date => new Date(date.getFullYear(), date.getMonth(), date.getDate());

    const playReminderSound = () => {
      if (!reminderAudio) return;
      try {
        reminderAudio.currentTime = 0;
        const playPromise = reminderAudio.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(err => console.warn('Reminder audio playback blocked:', err));
        }
      } catch (err) {
        console.warn('Reminder audio error:', err);
      }
    };

    const showNextReminder = () => {
      if (!remindersQueue.value.length) {
        reminderVisible.value = false;
        activeReminder.value = null;
        if (reminderHideTimer) {
          clearTimeout(reminderHideTimer);
          reminderHideTimer = null;
        }
        return;
      }

      activeReminder.value = remindersQueue.value.shift();
      reminderVisible.value = true;

      if (reminderHideTimer) clearTimeout(reminderHideTimer);
      reminderHideTimer = setTimeout(() => {
        reminderVisible.value = false;
        activeReminder.value = null;
        reminderHideTimer = null;
        showNextReminder();
      }, 6000);
    };

    const enqueueReminder = (payload) => {
      remindersQueue.value.push(payload);
      if (!reminderVisible.value) {
        showNextReminder();
      }
    };

    const clearReminderVisuals = () => {
      remindersQueue.value = [];
      reminderVisible.value = false;
      activeReminder.value = null;
      if (reminderHideTimer) {
        clearTimeout(reminderHideTimer);
        reminderHideTimer = null;
      }
    };

    const scheduleReminders = (contactList) => {
      if (typeof window === 'undefined') return;
      clearReminderTimeouts();
      clearReminderVisuals();

      const now = Date.now();
      const maxDelay = 2147483647; // ~24.8 giorni, limite setTimeout

      (contactList || reminderSource.value).forEach(contact => {
        const occurrences = [
          { date: contact.dataricontatto2, time: contact.orario, type: 'first' },
          { date: contact.dataricontatto3, time: contact.orario2, type: 'second' },
        ];

        occurrences.forEach(({ date, time, type }) => {
          const jsDate = toJsDate(date);
          const eventDate = combineDateAndTime(jsDate, time);
          if (!eventDate) return;

          const diff = eventDate.getTime() - now;
          if (diff <= 0 || diff > maxDelay) return;

          const timeoutId = window.setTimeout(() => {
            reminderTimeouts.delete(timeoutId);
            playReminderSound();
            const normalizedDate = jsDate ? normalizeDay(jsDate) : null;
            const displayName = [contact.name, contact.surname]
              .filter(Boolean)
              .join(' ')
              .trim() || 'Senza nominativo';
            const typeLabel = type === 'second' ? '2ª chiamata' : 'Promemoria';
            enqueueReminder({
              contactId: contact.uid || contact.id,
              displayName,
              phone: contact.telefono || '',
              email: contact.email || '',
              time: time || '--:--',
              date: normalizedDate,
              type,
              typeLabel,
            });
          }, diff);

          reminderTimeouts.add(timeoutId);
        });
      });
    };

    const parseInputDate = value => {
      if (!value) return null;
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return null;
      return normalizeDay(parsed);
    };

    const getDefaultWeekRange = () => {
      const today = normalizeDay(new Date());
      const dayOfWeek = today.getDay();
      const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      const start = new Date(today);
      start.setDate(start.getDate() + diffToMonday);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      return { start, end };
    };

    const calendarWeekStart = ref(getDefaultWeekRange().start);

    const calendarRange = computed(() => {
      const startInput = parseInputDate(startDateCall.value);
      const endInput = parseInputDate(endDateCall.value);

      if (startInput || endInput) {
        const start = startInput || endInput;
        const end = endInput || startInput;
        if (start.getTime() > end.getTime()) {
          return { start: end, end: start };
        }
        return { start, end };
      }

      const start = normalizeDay(calendarWeekStart.value);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      return { start, end };
    });

    const toInputDateValue = (value) => {
      const date = toJsDate(value);
      if (!date) return '';
      return date.toISOString().slice(0, 10);
    };

    const buildCalendarColumns = (start, end) => {
      const columns = [];
      const cursor = new Date(start);
      while (cursor.getTime() <= end.getTime()) {
        const dateObj = new Date(cursor);
        columns.push({
          dateObj,
          dateKey: buildDateKey(dateObj),
          dateLabel: formatCalendarHeader(dateObj),
          items: [],
        });
        cursor.setDate(cursor.getDate() + 1);
      }
      return columns;
    };

    const calendarEvents = computed(() => {
      const { start, end } = calendarRange.value;
      const columns = buildCalendarColumns(start, end);
      const columnMap = new Map(columns.map(column => [column.dateKey, column]));

      const sourceContacts = agendaContacts.value.length ? agendaContacts.value : combinedContacts.value;

      sourceContacts.forEach(contact => {
        const occurrences = [
          { date: contact.dataricontatto2, time: contact.orario, type: 'first' },
          { date: contact.dataricontatto3, time: contact.orario2, type: 'second' },
        ];

        occurrences.forEach(({ date, time, type }) => {
          const rawDate = toJsDate(date);
          if (!rawDate) return;

          const normalized = normalizeDay(rawDate);
          if (normalized < start || normalized > end) return;

          const key = buildDateKey(normalized);
          const entry = columnMap.get(key);
          if (!entry) return;

          const timeValue = time || '';
          const displayName = [contact.name, contact.surname]
            .filter(Boolean)
            .join(' ')
            .trim();

          entry.items.push({
            id: `${contact.uid || 'contact'}-${type}-${entry.items.length}`,
            contact,
            displayName: displayName || 'Senza nominativo',
            phone: contact.telefono || '',
            email: contact.email || '',
            displayTime: timeValue || '--:--',
            sortValue: timeToMinutes(timeValue) + (type === 'second' ? 0.01 : 0),
            type,
            typeLabel: type === 'second' ? '2ª chiamata' : 'Promemoria',
            operatore: contact.operatore2 || contact.operatore || '',
            operatoreSecondario: contact.operatore3 || '',
          });
        });
      });

      return columns.map(column => ({
        ...column,
        items: column.items.sort((a, b) => {
          const diff = a.sortValue - b.sortValue;
          if (diff !== 0) return diff;
          return a.displayName.localeCompare(b.displayName);
        }),
      }));
    });

    const calendarHasEvents = computed(() =>
      calendarEvents.value.some(column => column.items.length > 0)
    );

    const isCalendarManualRange = computed(() => !!startDateCall.value || !!endDateCall.value);

    const calendarRangeLabel = computed(() => {
      const { start, end } = calendarRange.value;
      const fmt = (date) => date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      return `${fmt(start)} → ${fmt(end)}`;
    });

    const deriveCurrentWeekStart = () => {
      const manualStart = parseInputDate(startDateCall.value);
      if (manualStart) {
        return new Date(manualStart);
      }
      return new Date(calendarWeekStart.value);
    };

    const shiftCalendarWeek = (days) => {
      const base = deriveCurrentWeekStart();
      base.setDate(base.getDate() + days);
      if (startDateCall.value || endDateCall.value) {
        startDateCall.value = '';
        endDateCall.value = '';
      }
      calendarWeekStart.value = normalizeDay(base);
      lastAgendaRangeKey.value = '';
    };

    const goToPreviousWeek = () => shiftCalendarWeek(-7);
    const goToNextWeek = () => shiftCalendarWeek(7);
    const goToCurrentWeek = () => {
      if (startDateCall.value || endDateCall.value) {
        startDateCall.value = '';
        endDateCall.value = '';
      }
      calendarWeekStart.value = getDefaultWeekRange().start;
      lastAgendaRangeKey.value = '';
    };

    const reminderSource = computed(() => {
      const map = new Map();
      combinedContacts.value.forEach(contact => {
        if (contact && (contact.uid || contact.id)) {
          map.set(contact.uid || contact.id, contact);
        }
      });
      agendaContacts.value.forEach(contact => {
        if (contact && (contact.uid || contact.id)) {
          map.set(contact.uid || contact.id, contact);
        }
      });
      return Array.from(map.values());
    });

    const filteredContacts = computed(() => {
      const isEmpty = v => v == null || v === '';

      let list = combinedContacts.value.filter(contact => {
        const stateFilter = (() => {
          const f = filterByState.value;
          if (!f) return true;
          if (f === 'no_selection') {
            return isEmpty(contact.stato) && isEmpty(contact.stato2) && isEmpty(contact.stato3);
          }
          return [contact.stato, contact.stato2, contact.stato3].some(s => s === f);
        })();

        const operatorFilter = !filterByOperator.value
          || [contact.operatore, contact.operatore2, contact.operatore3].includes(filterByOperator.value);

        let originFilter = true;
        if (filterByContattoPreso.value) {
          originFilter = contact.contattopreso === filterByContattoPreso.value;
        }

        const lavoratoFilter = !filterByLavorato.value
          || (filterByLavorato.value === 'true' && !!contact.lavorato)
          || (filterByLavorato.value === 'false' && !contact.lavorato);

        const studioFilter = !filterByStudio.value || contact.studio === filterByStudio.value;

        const isPurchased = isAcquistato(contact);
        let acquistatoFilter = true;
        if (filterByAcquistato.value) {
          acquistatoFilter = isPurchased;
        }
        if (filterByNonAcquistato.value) {
          acquistatoFilter = acquistatoFilter && !isPurchased;
        }

        let acquistatoDateFilter = true;
        const acquistoDateValue = getAcquistoDate(contact);
        if ((startAcquisto.value || endAcquisto.value) && acquistoDateValue) {
          const purchaseDate = toJsDate(acquistoDateValue);
          acquistatoDateFilter = isWithinRange(purchaseDate, startAcquisto.value, endAcquisto.value);
        } else if (startAcquisto.value || endAcquisto.value) {
          acquistatoDateFilter = false;
        }

        return stateFilter
          && operatorFilter
          && originFilter
          && lavoratoFilter
          && studioFilter
          && acquistatoFilter
          && acquistatoDateFilter;
      });

      if (filterByOperator.value) {
        list.sort((a, b) => (a.orario || '00:00').localeCompare(b.orario || '00:00'));
      }

      return list;
    });

    // ===== Modale seconda chiamata =====
    const openTextModalSecond = contact => {
      currentContact.value = contact;
      currentContact.value.consiglio2 = contact.consiglio2 || '';
      currentContact.value.notecontatto2 = contact.notecontatto2 || '';
      currentContact.value.esito2 = contact.esito2 || '';
      showModalSecond.value = true;
    };
    const closeModalSecond = () => { showModalSecond.value = false; currentContact.value = null; };
    const saveSecondCall = async () => {
      if (!currentContact.value?.uid) return;
      const contactRef = doc(db, 'contatti', currentContact.value.uid);
      try {
        await updateDoc(contactRef, {
          consiglio2: currentContact.value.consiglio2 || '',
          notecontatto2: currentContact.value.notecontatto2 || '',
          esito2: currentContact.value.esito2 || '',
        });
        const payload = {
          consiglio2: currentContact.value.consiglio2,
          notecontatto2: currentContact.value.notecontatto2,
          esito2: currentContact.value.esito2,
        };
        const idx = contacts.value.findIndex(c => c.uid === currentContact.value.uid);
        if (idx !== -1) {
          Object.assign(contacts.value[idx], payload);
        }
        const idxAcquisto = acquistoContacts.value.findIndex(c => c.uid === currentContact.value.uid);
        if (idxAcquisto !== -1) {
          Object.assign(acquistoContacts.value[idxAcquisto], payload);
        }
        closeModalSecond();
      } catch (e) {
        console.error('Errore salvataggio 2ª chiamata', e);
      }
    };



    const handleDateChange = (contact, fieldName) => {
      if (contact[fieldName]) {
        const date = new Date(contact[fieldName]);
        contact[fieldName] = Timestamp.fromDate(date);
      }
      updateContactField(contact, fieldName);
      showDatePicker.value = null;
    };

    const hasReminderData = (contact, dateField, timeField) =>
      !!(contact?.[dateField] || contact?.[timeField]);

    const calendarStatusOptions = CALENDAR_STATUS_OPTIONS;

    const normalizeCalendarStatus = value => {
      const normalized = String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, '_');
      return CALENDAR_STATUS_VALUES.has(normalized) ? normalized : '';
    };

    const getCalendarStatusUpdateKey = (contact, statusField) =>
      `${String(contact?.uid || '')}:${statusField}`;

    const isCalendarStatusUpdating = (contact, statusField) =>
      calendarStatusUpdateLocks.value.has(getCalendarStatusUpdateKey(contact, statusField));

    const setCalendarStatusUpdateLock = (key, isLocked) => {
      const nextLocks = new Set(calendarStatusUpdateLocks.value);
      if (isLocked) nextLocks.add(key);
      else nextLocks.delete(key);
      calendarStatusUpdateLocks.value = nextLocks;
    };

    const getLocalContactCopies = contact => {
      const contactId = String(contact?.uid || '');
      if (!contactId) return [];

      return Array.from(new Set([
        contact,
        currentContact.value,
        ...contacts.value,
        ...acquistoContacts.value,
        ...cache.value,
        ...agendaContacts.value,
      ].filter(item => String(item?.uid || '') === contactId)));
    };

    const isCalendarStatusSelected = (contact, statusField, status) =>
      normalizeCalendarStatus(contact?.[statusField]) === status;

    const toggleCalendarStatus = async (contact, statusField, status) => {
      if (!contact?.uid || !CALENDAR_STATUS_FIELDS.has(statusField) || !CALENDAR_STATUS_VALUES.has(status)) {
        console.error('Stato agenda non valido o uid contatto mancante.');
        return;
      }

      const updateKey = getCalendarStatusUpdateKey(contact, statusField);
      if (calendarStatusUpdateLocks.value.has(updateKey)) return;

      const currentStatus = normalizeCalendarStatus(contact[statusField]);
      const nextStatus = currentStatus === status ? '' : status;
      const localCopies = getLocalContactCopies(contact);
      const snapshots = localCopies.map(item => ({
        item,
        hadValue: Object.prototype.hasOwnProperty.call(item, statusField),
        value: item[statusField],
      }));

      setCalendarStatusUpdateLock(updateKey, true);
      localCopies.forEach(item => {
        if (nextStatus) item[statusField] = nextStatus;
        else delete item[statusField];
      });

      try {
        await updateDoc(doc(db, 'contatti', contact.uid), {
          [statusField]: nextStatus || deleteField(),
        });
      } catch (error) {
        snapshots.forEach(({ item, hadValue, value }) => {
          if (hadValue) item[statusField] = value;
          else delete item[statusField];
        });
        console.error(`Errore aggiornamento ${statusField}:`, error);
      } finally {
        setCalendarStatusUpdateLock(updateKey, false);
      }
    };

    const resetReminderFields = async (contact, dateField, timeField) => {
      if (!contact || !contact.uid) {
        console.error('Invalid contact data, uid mancante.');
        return;
      }
      const payload = {
        [dateField]: null,
        [timeField]: '',
      };
      try {
        const refDoc = doc(db, 'contatti', contact.uid);
        await updateDoc(refDoc, payload);
        Object.assign(contact, payload);

        const updateLocal = (listRef) => {
          const idx = listRef.value.findIndex(c => c.uid === contact.uid);
          if (idx !== -1) Object.assign(listRef.value[idx], payload);
        };
        updateLocal(contacts);
        updateLocal(acquistoContacts);
        updateLocal(cache);
        updateLocal(agendaContacts);
      } catch (error) {
        console.error('Errore reset data/orario contatto:', error);
      }
    };

    const handleCreatedDateChange = (contact, dateValue) => {
      if (!dateValue) return;
      const date = new Date(dateValue);
      const ts = Timestamp.fromDate(date);
      contact.created_time = ts;
      updateContactField(contact, 'created_time');
    };

    const handleAcquistoDateChange = async (contact, dateValue) => {
      if (!contact?.uid) return;
      if (hasOrderMatch(contact)) {
        console.warn('Data acquisto gestita da ordine: modifica manuale ignorata.');
        return;
      }
      let timestamp = null;
      if (dateValue) {
        const date = new Date(dateValue);
        if (!Number.isNaN(date.getTime())) {
          timestamp = Timestamp.fromDate(date);
        }
      }

      try {
        const refDoc = doc(db, 'contatti', contact.uid);
        await updateDoc(refDoc, {
          acquistatoAt: timestamp,
          acquistato: timestamp ? 'Si' : 'No',
        });
        contact.acquistatoAt = timestamp;
        contact.acquistato = timestamp ? 'Si' : 'No';
        const idx = acquistoContacts.value.findIndex(c => c.uid === contact.uid);
        if (idx !== -1) {
          acquistoContacts.value[idx].acquistatoAt = timestamp;
          acquistoContacts.value[idx].acquistato = contact.acquistato;
        }
      } catch (error) {
        console.error('Errore aggiornando la data di acquisto:', error);
      }
    };

    const openContactReminderModal = (contact) => {
      reminderModalContact.value = contact;
      reminderForm.dueAt = '';
      reminderForm.note = '';
      reminderForm.consultantName = '';
      reminderForm.consultantEmail = '';
      showReminderModal.value = true;
    };

    const closeContactReminderModal = () => {
      showReminderModal.value = false;
      reminderModalContact.value = null;
      reminderForm.dueAt = '';
      reminderForm.note = '';
      reminderForm.consultantName = '';
      reminderForm.consultantEmail = '';
    };

    const saveContactReminder = async () => {
      if (isSavingReminder.value) return;
      const contact = reminderModalContact.value;
      if (!contact) return;

      if (!reminderForm.dueAt || !reminderForm.consultantEmail) {
        alert('Imposta data/ora e email del consulente.');
        return;
      }

      const dueDate = new Date(reminderForm.dueAt);
      if (Number.isNaN(dueDate.getTime())) {
        alert('Data promemoria non valida.');
        return;
      }

      isSavingReminder.value = true;
      try {
        await addDoc(collection(db, 'contattiPromemoria'), {
          contactId: contact.uid || null,
          contactName: [contact.name, contact.surname].filter(Boolean).join(' ').trim() || contact.email || 'Contatto senza nome',
          contactEmail: contact.email || '',
          contactPhone: contact.telefono || '',
          note: reminderForm.note?.trim() || '',
          dueAt: Timestamp.fromDate(dueDate),
          consultantName: reminderForm.consultantName?.trim() || '',
          consultantEmail: reminderForm.consultantEmail?.trim().toLowerCase(),
          createdAt: Timestamp.now(),
          createdBy: auth.currentUser?.uid || null,
          createdByEmail: auth.currentUser?.email || '',
          done: false,
        });
        closeContactReminderModal();
      } catch (error) {
        console.error('Errore creazione promemoria contatto:', error);
        alert('Errore nella creazione del promemoria.');
      } finally {
        isSavingReminder.value = false;
      }
    };

    const openDatePicker = contactId => { showDatePicker.value = contactId; };

    // ===== Batch fetch degli utenti per il match =====
    const fetchUsersByEmailsAndPhones = async (emailsLower, phones) => {
      const uniqEmailsLower = Array.from(new Set((emailsLower || []).filter(Boolean)));
      const uniqPhones = Array.from(new Set((phones || []).filter(Boolean)));

      const emailBuckets = chunk(uniqEmailsLower, 10);
      const phoneBuckets = chunk(uniqPhones, 10);

      const usersByEmail = new Map();
      const usersByPhone = new Map();
      const pushUserByKey = (map, key, user) => {
        if (!key) return;
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(user);
      };
      const buildMatchedUser = (data = {}, docId = '') => ({
        uid: data.uid || null,
        docId,
        name: data.name || '',
        surname: data.surname || '',
        email: data.email || '',
        phone: data.phone || data.telefono || '',
      });
      const indexUserByPhone = (data = {}, docId = '') => {
        const user = buildMatchedUser(data, docId);
        const phoneKeys = new Set();
        [data.phone, data.telefono].forEach((rawPhone) => {
          const trimmedPhone = String(rawPhone || '').trim();
          if (!trimmedPhone) return;
          phoneKeys.add(trimmedPhone);
          buildPhoneMatchVariants(trimmedPhone).forEach(variant => phoneKeys.add(variant));
        });
        phoneKeys.forEach((key) => {
          pushUserByKey(usersByPhone, key, user);
        });
      };

      // emailLower
      for (const b of emailBuckets) {
        const q1 = query(collection(db, 'users'), where('emailLower', 'in', b));
        const snap1 = await getDocs(q1);
        snap1.forEach(d => {
          const data = d.data() || {};
          const key = (data.emailLower || '').trim();
          if (!key) return;
          pushUserByKey(usersByEmail, key, buildMatchedUser(data, d.id));
        });
      }
      // fallback email (case-insensitive)
      const missing = uniqEmailsLower.filter(e => !usersByEmail.has(e));
      if (missing.length) {
        const buckets = chunk(missing, 10);
        for (const b of buckets) {
          const q2 = query(collection(db, 'users'), where('email', 'in', b));
          const snap2 = await getDocs(q2);
          snap2.forEach(d => {
            const data = d.data() || {};
            const key = String(data.email || '').trim().toLowerCase();
            if (!key) return;
            pushUserByKey(usersByEmail, key, buildMatchedUser(data, d.id));
          });
        }
      }
      // phone
      for (const b of phoneBuckets) {
        const [snapPhone, snapTelefono] = await Promise.all([
          getDocs(query(collection(db, 'users'), where('phone', 'in', b))),
          getDocs(query(collection(db, 'users'), where('telefono', 'in', b))),
        ]);
        [snapPhone, snapTelefono].forEach((snap) => {
          snap.forEach(d => {
            const data = d.data() || {};
            indexUserByPhone(data, d.id);
          });
        });
      }

      return { usersByEmail, usersByPhone };
    };


    // helper riutilizzabile
    const enrichMatches = async (list) => {
      // prendo solo i contatti da fonti esterne che supportano il match utente
      const candidates = list.filter(c => isUserMatchSource(c));

      const emailsLower = candidates.map(c => (c.email || '').trim().toLowerCase()).filter(Boolean);
      const phonesToCheck = candidates.flatMap(c => buildPhoneMatchVariants(c.telefono || ''));

      const { usersByEmail, usersByPhone } =
        await fetchUsersByEmailsAndPhones(emailsLower, phonesToCheck);

      const emailKeySet = new Set(usersByEmail.keys());
      const phoneKeySet = new Set(usersByPhone.keys());

      const dedupByKey = (arr) => {
        const m = new Map();
        arr.forEach(u => {
          const k = u.uid || u.docId;
          if (!k) return;
          if (!m.has(k)) m.set(k, u);
        });
        return Array.from(m.values());
      };

      return list.map(c => {
        if (!isUserMatchSource(c)) return c;

        const emailKey = (c.email || '').trim().toLowerCase();
        const emailUsers = emailKey && emailKeySet.has(emailKey)
          ? (usersByEmail.get(emailKey) || [])
          : [];

        const pvars = buildPhoneMatchVariants(c.telefono || '');
        const phoneUsers = pvars.flatMap(v => phoneKeySet.has(v) ? (usersByPhone.get(v) || []) : []);

        const emailMatch = emailUsers.length > 0;
        const phoneMatch = phoneUsers.length > 0;
        const phoneIds = new Set(phoneUsers.map(u => u.uid || u.docId));
        const both = emailUsers.filter(u => phoneIds.has(u.uid || u.docId));

        let strength = 'none';
        if (emailMatch && phoneMatch) strength = 'strong';
        else if (emailMatch) strength = 'email';
        else if (phoneMatch) strength = 'phone';

        const best = both[0] || emailUsers[0] || phoneUsers[0] || null;
        const bestUid = best ? (best.uid || best.docId) : null;
        const savedStrength = ['strong', 'email', 'phone'].includes(c?.matchedUserBy)
          ? c.matchedUserBy
          : 'none';
        const savedUid = String(c?.matchedUserUid || '').trim() || null;
        const resolvedStrength = strength !== 'none' ? strength : savedStrength;
        const resolvedUid = bestUid || savedUid;

        return {
          ...c,
          _matchEmail: emailMatch,
          _matchPhone: phoneMatch,
          _matchStrength: resolvedStrength,
          _matchedUserUid: resolvedUid,
          _matchedUsers: dedupByKey([...emailUsers, ...phoneUsers])
            .slice(0, 5)
            .map(u => ({ uid: u.uid || u.docId, name: u.name, surname: u.surname, email: u.email })),
        };
      });
    };

    const normalizeEmailKey = (value = '') => (value || '').toString().trim().toLowerCase();
    const normalizeProductName = (value = '') => (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
    const resolveOrderAmount = (order) => {
      if (!order || typeof order !== 'object') return 0;
      const fields = ['totalPrice', 'total', 'amount', 'grandTotal', 'orderTotal'];
      for (const field of fields) {
        const raw = order[field];
        if (raw === undefined || raw === null || raw === '') continue;
        const num = Number(raw);
        if (Number.isFinite(num)) return num;
        if (typeof raw === 'string') {
          const normalized = Number(raw.replace(',', '.'));
          if (Number.isFinite(normalized)) return normalized;
        }
      }
      if (Array.isArray(order.products)) {
        const sum = order.products.reduce((acc, item) => {
          const price = Number(item?.price ?? item?.totalPrice ?? item?.total) || 0;
          const qty = Number(item?.quantity) || 1;
          return acc + price * qty;
        }, 0);
        if (Number.isFinite(sum)) return sum;
      }
      return 0;
    };
    const isCoachingDayOnlineOrder = (order) => {
      if (!order || typeof order !== 'object') return false;
      const target = 'coaching day online';
      const names = [];

      if (Array.isArray(order.products)) {
        order.products.forEach((item) => {
          const name = item?.name || item?.title || item?.productName || item?.sku;
          const normalized = normalizeProductName(name);
          if (normalized) names.push(normalized);
        });
      }

      if (!names.length) {
        const fallback = order.productName || order.orderName || order.orderTitle || order.title || order.name;
        const normalized = normalizeProductName(fallback);
        if (normalized) names.push(normalized);
      }

      if (!names.length) return false;
      return names.every((name) => name === target);
    };
    const isFreeCoachingDayOnlineOrder = (order) => {
      if (!isCoachingDayOnlineOrder(order)) return false;
      const total = resolveOrderAmount(order);
      return Number.isFinite(total) && total <= 0;
    };
    const orderStatusIsPaid = status => {
      const normalized = String(status || '').toLowerCase();
      return [
        'pagato',
        'paid',
        'completed',
        'processing',
        'wc-processing',
        'wc-completed',
      ].includes(normalized);
    };
    const parseOrderDateMs = (value) => {
      if (!value) return null;
      if (typeof value.toDate === 'function') {
        try {
          return value.toDate().getTime();
        } catch (err) {
          console.warn('parseOrderDateMs toDate error:', err);
          return null;
        }
      }
      const parsed = new Date(String(value).replace(' ', 'T'));
      const ms = parsed.getTime();
      return Number.isNaN(ms) ? null : ms;
    };
    const pickBetterOrder = (current, candidate) => {
      if (!candidate) return current || null;
      if (!current) return candidate;
      if (candidate.paid && !current.paid) return candidate;
      if (!candidate.paid && current.paid) return current;
      const currDate = current.dateMs ?? 0;
      const candDate = candidate.dateMs ?? 0;
      return candDate > currDate ? candidate : current;
    };
    const fetchOrderMatchesForContacts = async (list = []) => {
      const emails = new Set();

      list.forEach(c => {
        const emailKey = normalizeEmailKey(c.email);
        if (emailKey) emails.add(emailKey);
      });

      const ordersByEmail = new Map();

      const consider = (map, key, order) => {
        const paid = orderStatusIsPaid(order?.status);
        if (!paid) return;
        if (isFreeCoachingDayOnlineOrder(order)) return;
        const candidate = {
          order,
          paid,
          dateMs: parseOrderDateMs(order?.orderDate || order?.updatedAt || order?.importedAt),
        };
        const best = pickBetterOrder(map.get(key), candidate);
        if (best) map.set(key, best);
      };

      const runFieldQuery = async (valuesSet, field, map, normalizeValue = v => v) => {
        const buckets = chunk(Array.from(valuesSet), 10);
        for (const bucket of buckets) {
          if (!bucket.length) continue;
          const q = query(collection(db, 'orders'), where(field, 'in', bucket));
          const snap = await getDocs(q);
          snap.forEach(docSnap => {
            const data = { _id: docSnap.id, ...docSnap.data() };
            const rawValue = data[field];
            const normalized = normalizeValue(rawValue);
            if (!normalized) return;
            consider(map, normalized, data);
          });
        }
      };

      await Promise.all([
        runFieldQuery(emails, 'userEmail', ordersByEmail, normalizeEmailKey),
        runFieldQuery(emails, 'customerEmail', ordersByEmail, normalizeEmailKey),
      ]);

      return { ordersByEmail };
    };

    const resolveOrderMatchForContact = (contact, matches) => {
      const emailKey = normalizeEmailKey(contact.email);
      if (emailKey && matches.ordersByEmail.has(emailKey)) return matches.ordersByEmail.get(emailKey);

      return null;
    };

    const attachOrderMatches = async (list) => {
      if (!list.length) return [];
      try {
        const matches = await fetchOrderMatchesForContacts(list);
        return list.map(contact => {
          const match = resolveOrderMatchForContact(contact, matches);
          const purchaseDate = match?.dateMs ? new Date(match.dateMs) : null;
          return {
            ...contact,
            _orderMatch: match?.order || null,
            _orderPaid: !!match?.paid,
            _orderAcquistatoAt: purchaseDate,
          };
        });
      } catch (error) {
        console.error('Errore arricchimento ordini contatti:', error);
        return list;
      }
    };

    const decorateContacts = async (list) => {
      const matchedUsers = list.length ? await enrichMatches(list) : [];
      return matchedUsers.length ? attachOrderMatches(matchedUsers) : matchedUsers;
    };


    const mergeContactIntoList = (listRef, contact) => {
      if (!contact) return;
      const key = String(contact.uid || contact.id || contact.docId || '');
      if (!key) return;
      const existingIdx = listRef.value.findIndex(
        item => String(item?.uid || item?.id || item?.docId || '') === key
      );
      if (existingIdx >= 0) {
        const updated = listRef.value.slice();
        updated[existingIdx] = { ...updated[existingIdx], ...contact };
        listRef.value = updated;
      } else {
        listRef.value = [...listRef.value, contact];
      }
    };

    const ensureContactPresent = async (contactId) => {
      const key = contactId ? String(contactId) : null;
      if (!key) return;

      const existsIn = list => list.some(
        contact => String(contact?.uid || contact?.id || contact?.docId || '') === key
      );

      if (existsIn(contacts.value) || existsIn(acquistoContacts.value)) return;

      try {
        const contactSnap = await getDoc(doc(db, 'contatti', key));
        if (!contactSnap.exists()) return;
        const contactData = { uid: contactSnap.id, ...contactSnap.data() };
        const enrichedList = await decorateContacts([contactData]);
        const enrichedContact = enrichedList[0] || contactData;
        mergeContactIntoList(contacts, enrichedContact);
        mergeContactIntoList(cache, enrichedContact);
      } catch (error) {
        console.error('Errore caricamento contatto evidenziato:', error);
      }
    };

    const scrollToHighlightedContact = () => {
      if (typeof window === 'undefined') return;
      nextTick(() => {
        const id = highlightedContactId.value;
        if (!id) return;
        const row = document.querySelector(`[data-contact-id="${id}"]`);
        if (row && typeof row.scrollIntoView === 'function') {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    };

    const handleHighlightChange = async () => {
      const targetId = route.query.contactId ? String(route.query.contactId) : null;
      highlightedContactId.value = targetId;
      if (!targetId) return;
      await ensureContactPresent(targetId);
      scrollToHighlightedContact();
    };

    const handleQueryEmail = async () => {
      const email = route.query.email ? String(route.query.email).toLowerCase().trim() : '';
      searchEmail.value = email;
      if (email) {
        await applyFilters();
      } else if (!route.query.contactId) {
        await fetchContactsForLastTwoDays();
      }
    };








    // ====== Filtri / Ricerca ======
    const resetFilters = () => {
      filterByState.value = '';
      filterByStudio.value = '';
      filterByAcquistato.value = false;
      filterByNonAcquistato.value = false;
      filterByContattoPreso.value = '';
      filterByLavorato.value = '';
      filterByOperator.value = '';
      startDate.value = '';
      endDate.value = '';
      startDateLavorato.value = '';
      endDateLavorato.value = '';
      startDateCall.value = '';
      endDateCall.value = '';
      startAcquisto.value = '';
      endAcquisto.value = '';
      searchEmail.value = '';
      searchPhone.value = '';
      searchSurname.value = '';
      contacts.value = [...cache.value];
    };

    const resetSearch = () => {
      startDate.value = '';
      endDate.value = '';
      startDateLavorato.value = '';
      endDateLavorato.value = '';
      startDateCall.value = '';
      endDateCall.value = '';
      searchSurname.value = '';
      searchEmail.value = '';
      searchPhone.value = '';
      fetchContactsForLastTwoDays();
    };

    const deleteContact = async contact => {
      if (!contact.uid) {
        console.error('Invalid contact data: UID missing.');
        return;
      }
      if (!confirm('Sei sicuro di voler cancellare questo contatto?')) return;
      try {
        await deleteDoc(doc(db, 'contatti', contact.uid));
        contacts.value = contacts.value.filter(c => c.uid !== contact.uid);
        acquistoContacts.value = acquistoContacts.value.filter(c => c.uid !== contact.uid);
        cache.value = contacts.value;
      } catch (error) {
        console.error('Errore nella cancellazione del contatto:', error);
      }
    };

    const handlePasteData = async () => {
      const stripItalianPrefix = digits => {
        if (!digits) return '';
        if (digits.startsWith('0039')) return digits.slice(4);
        if (digits.startsWith('39')) return digits.slice(2);
        return digits;
      };

      const buildVariants = normalized => {
        if (!normalized) return [];
        const variants = new Set([normalized]);
        variants.add(`39${normalized}`);
        variants.add(`+39${normalized}`);
        variants.add(`0039${normalized}`);
        return Array.from(variants).filter(Boolean);
      };

      const lines = pastedData.value.trim().split(/\n/);
      const parsed = lines.map(line => {
        const rawMatch = line.match(/(\+39|39)?[0-9\s\-()]{9,}/);
        const rawPhone = rawMatch ? rawMatch[0] : '';
        const telefono = rawPhone.replace(/\D/g, '');
        const nameSurname = rawPhone ? line.replace(rawMatch[0], '').trim() : line.trim();
        const parts = nameSurname.split(/\s+/);
        const normalized = stripItalianPrefix(telefono);
        return {
          name: parts[0] || '',
          surname: parts.slice(1).join(' '),
          telefono,
          _normalized: normalized,
          _variants: buildVariants(normalized).concat(telefono ? [telefono] : []),
          contattopreso: selectedContattopreso.value,
        };
      }).filter(c => c.telefono.length >= 9);

      if (!parsed.length) {
        alert('Nessun numero valido trovato.');
        return;
      }

      const variantsToCheck = Array.from(
        new Set(
          parsed.flatMap(contact => contact._variants || []).filter(Boolean)
        )
      );

      const existingByNormalized = new Map();
      for (const bucket of chunk(variantsToCheck, 10)) {
        if (!bucket.length) continue;
        const q = query(collection(db, 'contatti'), where('telefono', 'in', bucket));
        const snap = await getDocs(q);
        snap.forEach(d => {
          const data = d.data() || {};
          const storedPhone = data.telefono || '';
          const normalized = stripItalianPrefix(normalizePhone(storedPhone));
          if (!normalized) return;
          if (!existingByNormalized.has(normalized)) {
            existingByNormalized.set(normalized, {
              telefono: storedPhone,
              name: data.name || '',
              surname: data.surname || '',
            });
          }
        });
      }

      const duplicates = [];
      const toSave = [];

      parsed.forEach(contact => {
        const normalized = contact._normalized;
        if (!normalized) {
          toSave.push(contact);
          return;
        }

        if (existingByNormalized.has(normalized)) {
          const existing = existingByNormalized.get(normalized);
          const displayName = contact.name
            || `${existing.name} ${existing.surname}`.trim()
            || 'Senza nome';
          const displayPhone = existing.telefono || contact.telefono;
          duplicates.push({ name: displayName.trim(), telefono: displayPhone });
        } else {
          toSave.push(contact);
        }
      });

      if (!toSave.length) {
        if (duplicates.length) {
          const duplicateList = duplicates
            .map(d => `- ${d.name || 'Senza nome'} (${d.telefono || 'n/d'})`)
            .join('\n');
          alert(`Contatti già presenti:\n${duplicateList}`);
        } else {
          alert('Tutti i contatti sono già presenti.');
        }
        closeModal();
        return;
      }

      const batch = writeBatch(db);
      const now = new Date();
      toSave.forEach(contact => {
        const payload = { ...contact };
        delete payload._normalized;
        delete payload._variants;
        const ref = doc(collection(db, 'contatti'));
        batch.set(ref, { ...payload, created_time: now });
      });
      await batch.commit();

      const localNew = toSave.map(contact => {
        const payload = { ...contact };
        delete payload._normalized;
        delete payload._variants;
        return { ...payload, created_time: now, uid: null };
      });

      contacts.value.unshift(...localNew);
      cache.value = [...contacts.value];
      pastedData.value = '';
      closeModal();

      if (duplicates.length) {
        const duplicateList = duplicates
          .map(d => `- ${d.name || 'Senza nome'} (${d.telefono || 'n/d'})`)
          .join('\n');
        alert(`Contatti già presenti:\n${duplicateList}`);
      }
    };

    const formatDate = timestamp => {
      if (timestamp instanceof Date) {
        return timestamp.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
      } else if (timestamp && typeof timestamp.toDate === 'function') {
        const date = timestamp.toDate();
        return date.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
      } else {
        return 'Data non valida';
      }
    };

    const openCreateContactModal = () => { showModal.value = true; };
    const openMultiContactModal = () => { showModal2.value = true; };
    const openCsvImportModal = () => {
      showCsvImportModal.value = true;
      isCsvImportAccordionOpen.value = false;
      showCsvFiltersModal.value = false;
      csvCurrentPage.value = 1;
      loadStoredCsvContacts();
    };
    const openFiltriContactModal = () => { showModal3.value = true; };
    const openMultiStatistic = () => { showModal4.value = true; };
    const toggleCsvImportAccordion = () => {
      isCsvImportAccordionOpen.value = !isCsvImportAccordionOpen.value;
    };
    const toggleCsvFiltersModal = () => {
      showCsvFiltersModal.value = !showCsvFiltersModal.value;
    };
    const closeCsvFiltersModal = () => {
      showCsvFiltersModal.value = false;
    };
    const goToCsvPage = (page) => {
      const safePage = Math.min(Math.max(1, page), csvTotalPages.value);
      csvCurrentPage.value = safePage;
    };
    const goToPreviousCsvPage = () => {
      goToCsvPage(csvCurrentPage.value - 1);
    };
    const goToNextCsvPage = () => {
      goToCsvPage(csvCurrentPage.value + 1);
    };
    const resetCsvSearchFilters = () => {
      csvSearchEmail.value = '';
      csvSearchSurname.value = '';
      csvSearchPhone.value = '';
    };
    const getCsvContactKey = (contact) => {
      if (contact?.uid) return `csv-doc::${contact.uid}`;
      const parts = [
        contact?.csvId || '',
        normalizeEmail(contact?.email || ''),
        contact?._normalized || stripItalianPrefix(normalizePhone(contact?.telefono || '')),
        contact?._lineNumber || '',
      ].filter(Boolean);
      return parts.join('::') || `csv-row::${contact?._lineNumber || 'unknown'}`;
    };
    const resetCsvStatusMaps = () => {
      csvCreatedContactMap.value = {};
      csvExistingContactMap.value = {};
      csvCreatingContactMap.value = {};
      csvDeletingContactMap.value = {};
    };
    const setCsvContactMapValue = (stateRef, contactKey, value = true) => {
      stateRef.value = { ...stateRef.value, [contactKey]: value };
    };
    const removeCsvContactMapValue = (stateRef, contactKey) => {
      if (!(contactKey in stateRef.value)) return;
      const next = { ...stateRef.value };
      delete next[contactKey];
      stateRef.value = next;
    };
    const isCsvContactCreated = contact => !!csvCreatedContactMap.value[getCsvContactKey(contact)];
    const isCsvContactExisting = contact => !!csvExistingContactMap.value[getCsvContactKey(contact)];
    const isCsvContactBusy = contact => !!csvCreatingContactMap.value[getCsvContactKey(contact)];
    const isCsvContactDeleting = contact => !!csvDeletingContactMap.value[getCsvContactKey(contact)];
    const canCreateCsvContact = contact =>
      !isCsvContactBusy(contact)
      && !isCsvContactDeleting(contact)
      && !isCsvContactCreated(contact)
      && !isCsvContactExisting(contact);
    const csvContactStatusLabel = (contact) => {
      if (isCsvContactDeleting(contact)) return 'Eliminazione...';
      if (isCsvContactBusy(contact)) return 'Creazione...';
      if (isCsvContactCreated(contact)) return 'Creato';
      if (isCsvContactExisting(contact)) return 'Già in contatti';
      return 'Da creare';
    };
    const csvContactStatusClass = (contact) => {
      if (isCsvContactDeleting(contact)) return 'csv-status-badge--busy';
      if (isCsvContactBusy(contact)) return 'csv-status-badge--busy';
      if (isCsvContactCreated(contact)) return 'csv-status-badge--created';
      if (isCsvContactExisting(contact)) return 'csv-status-badge--existing';
      return 'csv-status-badge--pending';
    };
    const csvContactStatusIcon = (contact) => {
      if (isCsvContactDeleting(contact)) return 'hourglass_top';
      if (isCsvContactBusy(contact)) return 'sync';
      if (isCsvContactCreated(contact)) return 'check_circle';
      if (isCsvContactExisting(contact)) return 'person_search';
      return 'radio_button_unchecked';
    };
    const csvContactActionLabel = (contact) => {
      if (isCsvContactDeleting(contact)) return 'Eliminazione...';
      if (isCsvContactBusy(contact)) return 'Creazione...';
      if (isCsvContactCreated(contact)) return 'Contatto creato';
      if (isCsvContactExisting(contact)) return 'Già presente';
      return 'Crea riga contatto';
    };
    const findExistingContactByCsv = async (contact) => {
      const emailKey = normalizeEmail(contact?.email || '');
      if (emailKey) {
        const emailQuery = query(collection(db, 'contatti'), where('email', '==', emailKey));
        const emailSnapshot = await getDocs(emailQuery);
        if (!emailSnapshot.empty) {
          return { uid: emailSnapshot.docs[0].id, ...emailSnapshot.docs[0].data(), match: 'email' };
        }
      }

      const phoneVariants = Array.from(new Set(contact?._variants || [])).filter(Boolean);
      for (const bucket of chunk(phoneVariants, 10)) {
        if (!bucket.length) continue;
        const phoneQuery = query(collection(db, 'contatti'), where('telefono', 'in', bucket));
        const phoneSnapshot = await getDocs(phoneQuery);
        if (!phoneSnapshot.empty) {
          return { uid: phoneSnapshot.docs[0].id, ...phoneSnapshot.docs[0].data(), match: 'phone' };
        }
      }

      return null;
    };
    const syncStoredCsvStatuses = async (list = csvStoredContacts.value) => {
      const createdMap = {};
      list.forEach(contact => {
        if (contact?.linkedContattoId) {
          createdMap[getCsvContactKey(contact)] = contact.linkedContattoId;
        }
      });
      csvCreatedContactMap.value = createdMap;
      csvExistingContactMap.value = {};

      const contactsToCheck = list.filter(contact => !contact?.linkedContattoId);
      if (!contactsToCheck.length) return;

      const existingEmails = new Set();
      const existingPhones = new Set();

      const emailBuckets = chunk(
        Array.from(new Set(contactsToCheck.map(contact => normalizeEmail(contact.email || '')).filter(Boolean))),
        10
      );
      const emailSnapshots = await Promise.all(
        emailBuckets
          .filter(bucket => bucket.length)
          .map(bucket => getDocs(query(collection(db, 'contatti'), where('email', 'in', bucket))))
      );
      emailSnapshots.forEach(emailSnapshot => {
        emailSnapshot.forEach(docSnap => {
          const email = normalizeEmail(docSnap.data()?.email || '');
          if (email) existingEmails.add(email);
        });
      });

      const phoneBuckets = chunk(
        Array.from(new Set(contactsToCheck.flatMap(contact => contact._variants || []).filter(Boolean))),
        10
      );
      const phoneSnapshots = await Promise.all(
        phoneBuckets
          .filter(bucket => bucket.length)
          .map(bucket => getDocs(query(collection(db, 'contatti'), where('telefono', 'in', bucket))))
      );
      phoneSnapshots.forEach(phoneSnapshot => {
        phoneSnapshot.forEach(docSnap => {
          const phone = stripItalianPrefix(normalizePhone(docSnap.data()?.telefono || ''));
          if (phone) existingPhones.add(phone);
        });
      });

      const existingMap = {};
      contactsToCheck.forEach(contact => {
        const contactKey = getCsvContactKey(contact);
        const email = normalizeEmail(contact.email || '');
        const phone = contact._normalized || stripItalianPrefix(normalizePhone(contact.telefono || ''));
        if ((email && existingEmails.has(email)) || (phone && existingPhones.has(phone))) {
          existingMap[contactKey] = true;
        }
      });
      csvExistingContactMap.value = existingMap;
    };
    const loadStoredCsvContacts = async () => {
      isCsvArchiveLoading.value = true;
      try {
        const snapshot = await getDocs(collection(db, csvContactsCollection));
        const list = snapshot.docs
          .map(docSnap => hydrateStoredCsvContact(docSnap.data(), docSnap.id))
          .sort((a, b) => {
            const aDate = toJsDate(a.created_time);
            const bDate = toJsDate(b.created_time);
            const aTime = aDate ? aDate.getTime() : 0;
            const bTime = bDate ? bDate.getTime() : 0;
            return bTime - aTime;
          });
        csvStoredContacts.value = list;
        isCsvArchiveLoading.value = false;
        void syncStoredCsvStatuses(list).catch(error => {
          console.error('Errore sincronizzazione stati archivio CSV:', error);
          resetCsvStatusMaps();
        });
      } catch (error) {
        console.error('Errore caricamento archivio CSV:', error);
        csvStoredContacts.value = [];
        resetCsvStatusMaps();
        isCsvArchiveLoading.value = false;
      }
    };
    const handleCsvFileChange = async (event) => {
      const [file] = event?.target?.files || [];
      if (!file) return;

      try {
        isCsvImportAccordionOpen.value = true;
        csvImportText.value = await file.text();
      } catch (error) {
        console.error('Errore lettura file CSV:', error);
        alert('Impossibile leggere il file CSV selezionato.');
      } finally {
        event.target.value = '';
      }
    };
    const saveCsvContactsToArchive = async () => {
      const previewRows = csvPreviewResult.value.rows;
      if (!previewRows.length) {
        alert('Nessun contatto valido da salvare nel DB.');
        return;
      }

      isCsvArchiveSaving.value = true;

      try {
        const seenEmails = new Set();
        const seenPhones = new Set();
        const uniqueRows = [];

        previewRows.forEach(contact => {
          const emailKey = normalizeEmail(contact.email || '');
          const phoneKey = contact._normalized || stripItalianPrefix(normalizePhone(contact.telefono || ''));
          const duplicateByEmail = emailKey && seenEmails.has(emailKey);
          const duplicateByPhone = phoneKey && seenPhones.has(phoneKey);

          if (duplicateByEmail || duplicateByPhone) {
            return;
          }

          if (emailKey) seenEmails.add(emailKey);
          if (phoneKey) seenPhones.add(phoneKey);
          uniqueRows.push(contact);
        });

        const existingEmails = new Set();
        const existingPhones = new Set();

        const emailBuckets = chunk(
          Array.from(new Set(uniqueRows.map(contact => normalizeEmail(contact.email || '')).filter(Boolean))),
          10
        );
        for (const bucket of emailBuckets) {
          if (!bucket.length) continue;
          const emailQuery = query(collection(db, csvContactsCollection), where('email', 'in', bucket));
          const emailSnapshot = await getDocs(emailQuery);
          emailSnapshot.forEach(docSnap => {
            const email = normalizeEmail(docSnap.data()?.email || '');
            if (email) existingEmails.add(email);
          });
        }

        const phoneBuckets = chunk(
          Array.from(new Set(uniqueRows.flatMap(contact => contact._variants || []).filter(Boolean))),
          10
        );
        for (const bucket of phoneBuckets) {
          if (!bucket.length) continue;
          const phoneQuery = query(collection(db, csvContactsCollection), where('telefono', 'in', bucket));
          const phoneSnapshot = await getDocs(phoneQuery);
          phoneSnapshot.forEach(docSnap => {
            const phone = stripItalianPrefix(normalizePhone(docSnap.data()?.telefono || ''));
            if (phone) existingPhones.add(phone);
          });
        }

        const rowsToSave = uniqueRows.filter(contact => {
          const emailKey = normalizeEmail(contact.email || '');
          const phoneKey = contact._normalized || stripItalianPrefix(normalizePhone(contact.telefono || ''));
          return !((emailKey && existingEmails.has(emailKey)) || (phoneKey && existingPhones.has(phoneKey)));
        });

        if (!rowsToSave.length) {
          alert('Nessun nuovo contatto CSV da salvare. Sono già presenti nell\'archivio.');
          return;
        }

        for (const batchRows of chunk(rowsToSave, 400)) {
          const batch = writeBatch(db);
          batchRows.forEach(contact => {
            const docRef = doc(collection(db, csvContactsCollection));
            batch.set(docRef, {
              name: contact.name || '',
              surname: contact.surname || '',
              email: normalizeEmail(contact.email || ''),
              telefono: contact.telefono || '',
              telefonoSecondario: contact.telefonoSecondario || '',
              codiceFiscale: contact.codiceFiscale || '',
              carrierMobile: contact.carrierMobile || '',
              contattopreso: contact.contattopreso || csvImportSource.value,
              csvId: contact.csvId || '',
              lineNumber: contact._lineNumber || null,
              created_time: Timestamp.now(),
              linkedContattoId: '',
            });
          });
          await batch.commit();
        }

        const skippedCount = (previewRows.length - rowsToSave.length);
        csvImportText.value = '';
        isCsvImportAccordionOpen.value = false;
        await loadStoredCsvContacts();
        alert(
          skippedCount
            ? `Salvati ${rowsToSave.length} contatti CSV. Saltati ${skippedCount} duplicati.`
            : `Salvati ${rowsToSave.length} contatti CSV nell'archivio.`
        );
      } catch (error) {
        console.error('Errore salvataggio archivio CSV:', error);
        alert('Errore durante il salvataggio del CSV nel DB.');
      } finally {
        isCsvArchiveSaving.value = false;
      }
    };
    const createCsvContactRow = async (contact) => {
      const contactKey = getCsvContactKey(contact);
      if (!canCreateCsvContact(contact)) return;

      setCsvContactMapValue(csvCreatingContactMap, contactKey);

      try {
        const existingContact = await findExistingContactByCsv(contact);
        if (existingContact) {
          setCsvContactMapValue(csvExistingContactMap, contactKey, existingContact.uid || true);
          return;
        }

        const createdAt = Timestamp.now();
        const payload = {
          name: contact.name || '',
          surname: contact.surname || '',
          email: normalizeEmail(contact.email || ''),
          telefono: contact.telefono || '',
          telefonoSecondario: contact.telefonoSecondario || '',
          codiceFiscale: contact.codiceFiscale || '',
          contattopreso: contact.contattopreso || csvImportSource.value,
          created_time: createdAt,
          importedFromCsv: true,
          csvImportId: contact.csvId || '',
          carrierMobile: contact.carrierMobile || '',
        };

        const docRef = await addDoc(collection(db, 'contatti'), payload);
        if (contact?.uid) {
          await updateDoc(doc(db, csvContactsCollection, contact.uid), {
            linkedContattoId: docRef.id,
            linkedAt: Timestamp.now(),
          });
        }
        const [enrichedContact] = await decorateContacts([{ uid: docRef.id, ...payload }]);
        const row = enrichedContact || { uid: docRef.id, ...payload };

        contacts.value = [row, ...contacts.value.filter(item => item.uid !== row.uid)];
        cache.value = [row, ...cache.value.filter(item => item.uid !== row.uid)];
        csvStoredContacts.value = csvStoredContacts.value.map(item => (
          item.uid === contact.uid
            ? { ...item, linkedContattoId: docRef.id, linkedAt: Timestamp.now() }
            : item
        ));

        setCsvContactMapValue(csvCreatedContactMap, contactKey, row.uid);
        removeCsvContactMapValue(csvExistingContactMap, contactKey);
      } catch (error) {
        console.error('Errore creazione contatto da CSV:', error);
        alert('Errore durante la creazione della riga contatto.');
      } finally {
        removeCsvContactMapValue(csvCreatingContactMap, contactKey);
      }
    };
    const deleteStoredCsvContact = async (contact) => {
      if (!contact?.uid) return;
      if (!confirm('Vuoi eliminare questo contatto dall\'archivio CSV?')) return;

      const contactKey = getCsvContactKey(contact);
      setCsvContactMapValue(csvDeletingContactMap, contactKey);

      try {
        await deleteDoc(doc(db, csvContactsCollection, contact.uid));
        csvStoredContacts.value = csvStoredContacts.value.filter(item => item.uid !== contact.uid);
        removeCsvContactMapValue(csvCreatedContactMap, contactKey);
        removeCsvContactMapValue(csvExistingContactMap, contactKey);
      } catch (error) {
        console.error('Errore eliminazione contatto CSV:', error);
        alert('Errore durante l\'eliminazione del contatto CSV.');
      } finally {
        removeCsvContactMapValue(csvDeletingContactMap, contactKey);
      }
    };
    const loadAgendaContacts = async () => {
      if (isAgendaLoading.value) {
        agendaReloadPending = true;
        return;
      }
      isAgendaLoading.value = true;
      try {
        const { start, end } = calendarRange.value;
        const rangeKey = `${start.getTime()}-${end.getTime()}`;

        if (!agendaReloadPending && rangeKey === lastAgendaRangeKey.value && agendaContacts.value.length) {
          return;
        }

        const startDay = new Date(start);
        startDay.setHours(0, 0, 0, 0);
        const endDay = new Date(end);
        endDay.setHours(23, 59, 59, 999);

        const startTs = Timestamp.fromDate(startDay);
        const endTs = Timestamp.fromDate(endDay);

        const contactsMap = new Map();

        const fetchRange = async field => {
          const rangeQuery = query(
            collection(db, 'contatti'),
            orderBy(field),
            where(field, '>=', startTs),
            where(field, '<=', endTs)
          );
          const snapshot = await getDocs(rangeQuery);
          snapshot.forEach(docSnap => {
            const data = { ...docSnap.data(), uid: docSnap.id };
            contactsMap.set(docSnap.id, data);
          });
        };

        await Promise.all([
          fetchRange('dataricontatto2'),
          fetchRange('dataricontatto3')
        ]);

        const list = Array.from(contactsMap.values());
        const enriched = list.length ? await enrichMatches(list) : [];
        agendaContacts.value = enriched;
        lastAgendaRangeKey.value = rangeKey;
      } catch (error) {
        console.error('Errore caricamento agenda:', error);
        agendaContacts.value = [];
        lastAgendaRangeKey.value = '';
      } finally {
        isAgendaLoading.value = false;
        if (agendaReloadPending) {
          agendaReloadPending = false;
          loadAgendaContacts();
        }
      }
    };

    const openCalendarView = () => {
      showCalendarView.value = true;
    };
    const closeModal = () => {
      showModal.value = false;
      showModal2.value = false;
      showCsvImportModal.value = false;
      showModal3.value = false;
      showModal4.value = false;
      showModal5.value = false;
      showCalendarView.value = false;
      agendaContacts.value = [];
      lastAgendaRangeKey.value = '';
      csvImportText.value = '';
      isCsvImportAccordionOpen.value = false;
      showCsvFiltersModal.value = false;
      csvSearchEmail.value = '';
      csvSearchSurname.value = '';
      csvSearchPhone.value = '';
      newContact.value = { name: '', surname: '', email: '', contattopreso: '', telefono: '' };
      contactField.value = {
        knownFrom: '', nearStudio: '', objectives: '', serviceExplanation: '',
        trainingExperience: '', pathologies: '', resultTime: '',
        consultantRecommendation: '', generalNotes: '',
      };
      currentContact.value = null;
    };
    const closeCalendarView = () => {
      showCalendarView.value = false;
      agendaContacts.value = [];
    };

    const applyFilters = async () => {
      let filteredContacts = [...cache.value];

      if (searchSurname.value) {
        filteredContacts = filteredContacts.filter(
          doc => doc.surname && doc.surname.toLowerCase().includes(searchSurname.value.toLowerCase())
        );
        if (filteredContacts.length === 0) {
          await searchBySurname();
          filteredContacts = [...contacts.value];
        }
      }
      if (searchEmail.value) {
        filteredContacts = filteredContacts.filter(
          doc => doc.email && doc.email.toLowerCase() === searchEmail.value.toLowerCase()
        );
        if (filteredContacts.length === 0) {
          await searchByEmail();
          filteredContacts = [...contacts.value];
        }
      }
      if (searchPhone.value) {
        let digits = normalizePhone(searchPhone.value);
        if (digits.startsWith('0039')) digits = digits.slice(4);
        else if (digits.startsWith('39')) digits = digits.slice(2);
        const variants = [digits, '39' + digits, '+39' + digits];
        filteredContacts = filteredContacts.filter(c => c.telefono && variants.includes(c.telefono));
        if (!filteredContacts.length) {
          await searchByPhone();
          filteredContacts = [...contacts.value];
        }
      }

      if (startDate.value && endDate.value) {
        await searchByDate();
        filteredContacts = [...contacts.value];
      }

      if (startDateLavorato.value && endDateLavorato.value) {
        await searchByLavoratoDate();
        const lavoratoMatches = [...contacts.value];
        if (
          searchSurname.value
          || searchEmail.value
          || searchPhone.value
          || (startDate.value && endDate.value)
        ) {
          const matchedIds = new Set(lavoratoMatches.map(contact => contact.uid).filter(Boolean));
          filteredContacts = filteredContacts.filter(contact => matchedIds.has(contact.uid));
        } else {
          filteredContacts = lavoratoMatches;
        }
      }

      contacts.value = filteredContacts;
    };



    const fetchContactsForLastTwoDays = async () => {
  const dayStart = new Date();
  dayStart.setDate(dayStart.getDate() - 1);
  dayStart.setHours(0, 0, 0, 0);

  const dayEnd = new Date();
  dayEnd.setHours(23, 59, 59, 999);

  const startTimestamp = Timestamp.fromDate(dayStart);
  const endTimestamp   = Timestamp.fromDate(dayEnd);

  try {
    const qContatti = query(
      collection(db, 'contatti'),
      where('created_time', '>=', startTimestamp),
      where('created_time', '<=', endTimestamp),
      orderBy('created_time', 'desc')
    );

    const snap = await getDocs(qContatti);
    const list = snap.docs.map(d => ({ ...d.data(), uid: d.id }));

    // arricchisco i contatti con match utenti e ordini
    const enriched = await decorateContacts(list);

    contacts.value = enriched;
    cache.value = enriched;
  } catch (error) {
    console.error('Failed to fetch contacts:', error);
  }
};

const searchByDate = async () => {
  if (!startDate.value || !endDate.value) {
    // se non ci sono date selezionate, torno alla lista base
    return fetchContactsForLastTwoDays();
  }

  const dayStart = new Date(startDate.value);
  dayStart.setHours(0, 0, 0, 0);

  const dayEnd = new Date(endDate.value);
  dayEnd.setHours(23, 59, 59, 999);

  const startTimestamp = Timestamp.fromDate(dayStart);
  const endTimestamp   = Timestamp.fromDate(dayEnd);

  try {
    const dateQuery = query(
      collection(db, 'contatti'),
      where('created_time', '>=', startTimestamp),
      where('created_time', '<=', endTimestamp),
      orderBy('created_time', 'desc')
    );

    const snap = await getDocs(dateQuery);
    const list = snap.docs.map(d => ({ ...d.data(), uid: d.id }));

    const enriched = await decorateContacts(list);

    // aggiorno solo la vista corrente (non tocco la cache)
    contacts.value = enriched;
  } catch (error) {
    console.error('Failed to fetch contacts by date:', error);
  }
};

const searchByLavoratoDate = async () => {
  if (!startDateLavorato.value || !endDateLavorato.value) {
    return fetchContactsForLastTwoDays();
  }

  const dayStart = new Date(startDateLavorato.value);
  dayStart.setHours(0, 0, 0, 0);

  const dayEnd = new Date(endDateLavorato.value);
  dayEnd.setHours(23, 59, 59, 999);

  const startTimestamp = Timestamp.fromDate(dayStart);
  const endTimestamp = Timestamp.fromDate(dayEnd);

  try {
    const lavoratoDateQuery = query(
      collection(db, 'contatti'),
      where('lavoratoAt', '>=', startTimestamp),
      where('lavoratoAt', '<=', endTimestamp),
      orderBy('lavoratoAt', 'desc')
    );

    const snap = await getDocs(lavoratoDateQuery);
    const list = snap.docs.map(d => ({ ...d.data(), uid: d.id }));
    const enriched = list.length ? await decorateContacts(list) : [];
    contacts.value = enriched;
  } catch (error) {
    console.error('Failed to fetch contacts by lavorato date:', error);
    contacts.value = [];
  }
};

    let acquistoFetchToken = 0;
    const refreshAcquistoContacts = async () => {
      const startValue = startAcquisto.value;
      const endValue = endAcquisto.value;
      const currentToken = ++acquistoFetchToken;

      if (!startValue && !endValue) {
        acquistoContacts.value = [];
        return;
      }

      try {
        const constraints = [orderBy('acquistatoAt', 'asc')];
        if (startValue) {
          const start = new Date(startValue);
          start.setHours(0, 0, 0, 0);
          constraints.push(where('acquistatoAt', '>=', Timestamp.fromDate(start)));
        }
        if (endValue) {
          const end = new Date(endValue);
          end.setHours(23, 59, 59, 999);
          constraints.push(where('acquistatoAt', '<=', Timestamp.fromDate(end)));
        }

        const qAcquisto = query(collection(db, 'contatti'), ...constraints);
        const snap = await getDocs(qAcquisto);
        const list = snap.docs.map(d => ({ ...d.data(), uid: d.id }));
        const enriched = list.length ? await decorateContacts(list) : [];

        if (currentToken === acquistoFetchToken) {
          acquistoContacts.value = enriched;
        }
      } catch (error) {
        console.error('Errore nel fetch per data acquisto:', error);
        if (currentToken === acquistoFetchToken) {
          acquistoContacts.value = [];
        }
      }
    };



    // eslint-disable-next-line no-unused-vars
    const searchByCallDate = async () => {
      if (startDateCall.value && endDateCall.value) {
        const dayStart = new Date(startDateCall.value); dayStart.setHours(0,0,0,0);
        const dayEnd = new Date(endDateCall.value);     dayEnd.setHours(23,59,59,999);
        const startTs = Timestamp.fromDate(dayStart);
        const endTs = Timestamp.fromDate(dayEnd);

        const makeQuery = field =>
          query(collection(db, 'contatti'),
                where(field, '>=', startTs),
                where(field, '<=', endTs),
                orderBy(field, 'desc'));

        try {
          const [snap2, snap3] = await Promise.all([
            getDocs(makeQuery('dataricontatto2')),
            getDocs(makeQuery('dataricontatto3'))
          ]);

          const list2 = snap2.docs.map(d => ({ ...d.data(), uid: d.id, callDate: d.data().dataricontatto2, _collection: 'contatti' }));
          const list3 = snap3.docs.map(d => ({ ...d.data(), uid: d.id, callDate: d.data().dataricontatto3, _collection: 'contatti' }));

          const merged = [...list2, ...list3];
          const uniqueByUid = Object.values(
            merged.reduce((acc, item) => {
              if (!acc[item.uid] || acc[item.uid].callDate.seconds < item.callDate.seconds) acc[item.uid] = item;
              return acc;
            }, {})
          );
          uniqueByUid.sort((a, b) => (a.orario || '00:00').localeCompare(b.orario || '00:00'));
          contacts.value = await decorateContacts(uniqueByUid);
        } catch (error) {
          console.error('Errore nel fetch dei contatti:', error);
        }
      } else {
        fetchContactsForLastTwoDays();
      }
    };

    const searchBySurname = async () => {
      if (!searchSurname.value) return fetchContactsForLastTwoDays();
      const orderedQuery = query(collection(db, 'contatti'), orderBy('created_time', 'desc'));
      const querySnapshot = await getDocs(orderedQuery);
      const searchValueLower = searchSurname.value.toLowerCase();
      const filtered = querySnapshot.docs.filter(d =>
        (d.data().surname || '').toLowerCase().includes(searchValueLower)
      );
      const mapped = filtered.map(d => ({ ...d.data(), uid: d.id, _collection: 'contatti' }));
      contacts.value = await decorateContacts(mapped);
    };

    const searchByEmail = async () => {
      if (!searchEmail.value) return fetchContactsForLastTwoDays();
      const emailQuery = query(collection(db, 'contatti'), where('email', '==', searchEmail.value.toLowerCase()));
      const querySnapshot = await getDocs(emailQuery);
      const mapped = querySnapshot.docs.map(d => ({ ...d.data(), uid: d.id, _collection: 'contatti' }));
      contacts.value = await decorateContacts(mapped);
    };

    const searchByPhone = async () => {
      if (!searchPhone.value) return fetchContactsForLastTwoDays();
      let digits = normalizePhone(searchPhone.value);
      if (digits.startsWith('0039')) digits = digits.slice(4);
      else if (digits.startsWith('39')) digits = digits.slice(2);
      const variants = [digits, '39' + digits, '+39' + digits];
      const phoneQuery = query(collection(db, 'contatti'), where('telefono', 'in', variants));
      const querySnapshot = await getDocs(phoneQuery);
      const mapped = querySnapshot.docs.map(d => ({ ...d.data(), uid: d.id, _collection: 'contatti' }));
      contacts.value = await decorateContacts(mapped);
    };

    const saveNewContact = async () => {
      if (newContact.value.name && newContact.value.contattopreso && newContact.value.telefono) {
        const normalize = str => str.replace(/\D/g, '');
        let digits = normalize(newContact.value.telefono);
        if (digits.startsWith('0039')) digits = digits.slice(4);
        else if (digits.startsWith('39')) digits = digits.slice(2);
        const variants = [digits, '39' + digits, '+39' + digits];

        const phoneQuery = query(collection(db, 'contatti'), where('telefono', 'in', variants));
        const snapshot = await getDocs(phoneQuery);
        if (!snapshot.empty) {
          alert('Questo numero (anche in formato 39 o +39) esiste già.');
          return;
        }

        await addDoc(collection(db, 'contatti'), {
          name: newContact.value.name,
          surname: newContact.value.surname,
          email: (newContact.value.email || '').trim().toLowerCase(),
          contattopreso: newContact.value.contattopreso,
          telefono: '+39' + digits,
          created_time: new Date(),
        });

        closeModal();
        fetchContactsForLastTwoDays();
      } else {
        alert('Assicurati di compilare tutti i campi obbligatori.');
      }
    };



    const updateContactField = async (contact, field) => {
  if (!contact || !contact.uid) {
    console.error('Invalid contact data, uid mancante.');
    return;
  }
  try {
    const ref = doc(db, 'contatti', contact.uid);
    let v = contact[field];
    if (field === 'telefono') v = (v || '').replace(/\D+/g, '');
    if (field === 'email') v = (v || '').trim().toLowerCase();
    if (field === 'created_time' && v?.toDate) v = v.toDate();
    await updateDoc(ref, { [field]: v ?? '' });
  } catch (error) {
    console.error(`Failed to update contatti ${field}:`, error);
  }
};

    const openNoteEditor = contact => {
      noteEditorContact.value = contact;
      noteEditorValue.value = getContactNoteValue(contact);
      showNoteModal.value = true;
      nextTick(() => {
        const textarea = document.querySelector('.note-editor-modal__textarea');
        if (textarea) textarea.focus();
      });
    };

    const closeNoteEditor = () => {
      showNoteModal.value = false;
      noteEditorValue.value = '';
      noteEditorContact.value = null;
    };

    const saveNoteEditor = async () => {
      if (!noteEditorContact.value) {
        closeNoteEditor();
        return;
      }
      const sanitized = noteEditorValue.value?.trim() || '';
      noteEditorContact.value.note = sanitized;
      await updateContactField(noteEditorContact.value, 'note');
      closeNoteEditor();
    };



    const toggleAccordion = () => { isAccordionOpen.value = !isAccordionOpen.value; };

    const openTextModal = (contact) => {
      currentContact.value = contact;
      contactField.value = {
        knownFrom: contact.knownFrom || '',
        nearStudio: contact.nearStudio || '',
        objectives: contact.objectives || '',
        serviceExplanation: contact.serviceExplanation || '',
        trainingExperience: contact.trainingExperience || '',
        pathologies: contact.pathologies || '',
        resultTime: contact.resultTime || '',
        consultantRecommendation: contact.consultantRecommendation || '',
        generalNotes: contact.generalNotes || '',
      };
      showModal5.value = true;
    };

    const closeTextModal = () => {
      showModal5.value = false;
      contactField.value = {
        knownFrom: '', nearStudio: '', objectives: '', serviceExplanation: '',
        trainingExperience: '', pathologies: '', resultTime: '',
        consultantRecommendation: '', generalNotes: '',
      };
      currentContact.value = null;
    };

    const saveTextField = async () => {
      if (currentContact.value && currentContact.value.uid) {
        const contactRef = doc(getFirestore(), 'contatti', currentContact.value.uid);
        try {
          await updateDoc(contactRef, contactField.value);
          Object.assign(currentContact.value, contactField.value);
          closeTextModal();
        } catch (error) {
          console.error('Errore nel salvataggio del campo testo:', error);
        }
      }
    };

    onMounted(async () => {
      await fetchContactsForLastTwoDays();
      await handleHighlightChange();
      await handleQueryEmail();
    });

    watch(
      () => route.query.contactId,
      () => {
        handleHighlightChange();
      }
    );

    watch(
      () => route.query.email,
      () => {
        handleQueryEmail();
      }
    );

    watch(
      filteredContacts,
      () => {
        if (highlightedContactId.value) {
          scrollToHighlightedContact();
        }
      },
      { flush: 'post' }
    );

    watch([startAcquisto, endAcquisto], () => {
      refreshAcquistoContacts();
    }, { immediate: true });

    watch([csvSearchEmail, csvSearchSurname, csvSearchPhone], () => {
      csvCurrentPage.value = 1;
    });

    watch(filteredCsvStoredContacts, () => {
      if (csvCurrentPage.value > csvTotalPages.value) {
        csvCurrentPage.value = csvTotalPages.value;
      }
    });

    watch(reminderSource, (list) => {
      scheduleReminders(list);
    }, { deep: true, immediate: true });

    watch(showCalendarView, (isOpen) => {
      if (isOpen) {
        if (!startDateCall.value && !endDateCall.value) {
          calendarWeekStart.value = getDefaultWeekRange().start;
        }
        lastAgendaRangeKey.value = '';
        loadAgendaContacts();
      }
    });

    watch(calendarRange, () => {
      if (showCalendarView.value) {
        loadAgendaContacts();
      }
    });

    watch([startDateCall, endDateCall], ([start, end]) => {
      if (!start && !end) {
        calendarWeekStart.value = getDefaultWeekRange().start;
      }
      lastAgendaRangeKey.value = '';
    });

    onUnmounted(() => {
      clearReminderTimeouts();
      clearReminderVisuals();
      if (reminderAudio) {
        reminderAudio.pause();
        reminderAudio = null;
      }
    });


    const exportToCSV = () => {
      const headers = [
        'Data creazione',
        'Contatto',
        'Ex cliente',
        'Lavorato',
        'Lavorato il',
        'Nome',
        'Cognome',
        'Telefono',
        'Email',
        'Citta',
        'Regione',
        'Preferenza contatto',
        'Stato contatto',
        'Data 1 chiamata',
        'Orario 1 chiamata',
        'Esito 1 chiamata',
        'Operatore contatto',
        'Operatore 1 chiamata',
        'Consiglio 1 chiamata',
        'Note chiamata 1',
        'Note generali',
        'Data 2 chiamata',
        'Orario 2 chiamata',
        'Esito 2 chiamata',
        'Operatore 2 chiamata',
        'Consiglio 2 chiamata',
        'Note chiamata 2',
        'Acquistato',
        'Acquistato il',
        'Studio',
        'Importo',
        'Ordine',
      ];

      const formatCsvDate = value => {
        const date = toJsDate(value);
        if (!date) return '';
        return date.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
      };

      const escapeCsvCell = value => {
        const rawValue = value == null ? '' : String(value);
        const normalizedValue = rawValue.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        return `"${normalizedValue.replace(/"/g, '""')}"`;
      };

      const rows = filteredContacts.value.map(contact => [
        formatCsvDate(contact.created_time),
        contact.contattopreso,
        contact.excliente ? 'Si' : 'No',
        contact.lavorato ? 'Si' : 'No',
        formatCsvDate(contact.lavoratoAt),
        contact.name,
        contact.surname,
        contact.telefono,
        contact.email,
        contact.citta,
        contact.regione,
        contact.prefcontatto,
        contact.stato,
        formatCsvDate(contact.dataricontatto2),
        contact.orario,
        contact.stato2,
        contact.operatore,
        contact.operatore2,
        contact.consiglio,
        contact.notecontatto1,
        getContactNoteValue(contact),
        formatCsvDate(contact.dataricontatto3),
        contact.orario2,
        contact.stato3,
        contact.operatore3,
        contact.consiglio2,
        contact.notecontatto2,
        isAcquistato(contact) ? 'Si' : 'No',
        formatCsvDate(getAcquistoDate(contact)),
        contact.studio,
        formatPrice(getImportoValue(contact)),
        orderLink(contact) || '',
      ]);

      if (!rows.length) {
        alert('Nessun contatto da esportare con i filtri correnti.');
        return;
      }

      const delimiter = ';';
      const csvContent = [
        headers.map(escapeCsvCell).join(delimiter),
        ...rows.map(row => row.map(escapeCsvCell).join(delimiter)),
      ].join('\r\n');
      const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', 'contatti_filtrati.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };

    return {
      // state
      contacts, cache, timeOptions,
      agendaContacts, isAgendaLoading,
      showModal, showModal2, showCsvImportModal, showModal3, showModal4, showModal5,
      showModalSecond, showCalendarView,
      showNoteModal,
      currentContact, isLoading,
      activeReminder, reminderVisible,
      noteEditorContact,
      noteEditorValue,
      highlightedContactId,
      csvImportText,
      csvImportSource,
      isCsvImportAccordionOpen,
      showCsvFiltersModal,
      csvCurrentPage,
      csvStoredContacts,
      csvSearchEmail,
      csvSearchSurname,
      csvSearchPhone,
      csvPreviewResult,
      filteredCsvStoredContacts,
      csvFilteredCount,
      csvPaginatedContacts,
      csvTotalPages,
      csvPageStart,
      csvPageEnd,
      csvVisiblePageNumbers,
      csvHasActiveSearch,
      csvActiveFilters,
      csvActiveFiltersCount,
      csvCreatedCount,
      csvExistingCount,
      isCsvArchiveLoading,
      isCsvArchiveSaving,
      // filters/search
      searchEmail, searchSurname, searchPhone, startDate, endDate, startDateLavorato, endDateLavorato, startDateCall, endDateCall,
      filterByState, filterByStudio, filterByContattoPreso, filterByAcquistato, filterByNonAcquistato, filterByOperator,
      startAcquisto, endAcquisto,
      // computed
      filteredContacts, totalContacts, nonRispondeCount, daRicontattareCount,
      sortedContacts, calendarEvents, calendarHasEvents,
      calendarRangeLabel, isCalendarManualRange,
      // methods
      formatDate, openCreateContactModal, closeModal, saveNewContact,
      applyFilters, resetSearch, resetFilters, deleteContact,
      handlePasteData, openMultiContactModal, openCsvImportModal, openMultiStatistic, openFiltriContactModal,
      openCalendarView, closeCalendarView,
      toggleCsvImportAccordion, toggleCsvFiltersModal, closeCsvFiltersModal, resetCsvSearchFilters,
      goToCsvPage, goToPreviousCsvPage, goToNextCsvPage,
      handleCsvFileChange, saveCsvContactsToArchive, createCsvContactRow, deleteStoredCsvContact,
      canCreateCsvContact, isCsvContactExisting, isCsvContactDeleting, csvContactStatusLabel, csvContactStatusClass, csvContactStatusIcon, csvContactActionLabel,
      handleDateChange, openDatePicker, handleCreatedDateChange, hasReminderData, resetReminderFields,
      calendarStatusOptions, normalizeCalendarStatus, isCalendarStatusSelected,
      isCalendarStatusUpdating, toggleCalendarStatus,
      handleAcquistoDateChange,
      openTextModal, closeTextModal, saveTextField,
      openTextModalSecond, closeModalSecond, saveSecondCall,
      updateContactField, toggleAccordion, isAccordionOpen,
      isMobileContactExpanded, toggleMobileContactDetails,
      selectedContattopreso, matchTitle, getUserProfileLink, exportToCSV,
      getContactNoteValue,
      userRole,              
      searchByCallDate, searchByLavoratoDate, isFromPopup, shouldShowMatchBadge,
      loadAgendaContacts,
      goToPreviousWeek, goToNextWeek, goToCurrentWeek,
      matchStrengthOf,
      filterByLavorato,
      toggleLavorato,
      toggleExCliente,
      toggleAcquistato,
      contactField,
      newContact,
      isAcquistato,
      getImportoValue,
      orderLink,
      formatPrice,
      hasOrderMatch,
      getAcquistoDate,
      openNoteEditor,
      closeNoteEditor,
      saveNoteEditor,
      toInputDateValue,
      showReminderModal,
      reminderModalContact,
      reminderForm,
      isSavingReminder,
      openContactReminderModal,
      closeContactReminderModal,
      saveContactReminder,


          
    };
  },
};
</script>


<style scoped>

.contacts-table {
  width: 100%;
  min-width: 1180px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.92rem;
  color: #1f2937;
    padding:7px!important;

}

.contacts-table thead th {
  position: sticky;
  top: 22px;
  z-index: 6;
  background: linear-gradient(180deg, #f7f9fc 0%, #eef2f7 100%);
  padding: 16px 18px;
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0f172a;
  border-bottom: 1px solid #dbe2f0;
  white-space: nowrap;
  margin-top: 22px;
}

.contacts-table tbody tr {
  --row-bg: #ffffff;
  transition: background-color 0.25s ease;
}

.contacts-table tbody tr:nth-child(even):not(.red-row) {
  --row-bg: #f9fbfd;
}

.contacts-table tbody tr:hover:not(.red-row) {
  --row-bg: #eef6ff;
}

.contacts-table tbody tr.red-row {
  --row-bg: rgba(248, 113, 113, 0.4);
  background-color: var(--row-bg) !important;
}

.contacts-table tbody tr.red-row:hover {
  --row-bg: rgba(239, 68, 68, 0.55);
  background-color: var(--row-bg) !important;
}

.contacts-table tbody tr.highlighted-contact {
  box-shadow: inset 0 0 0 2px #2563eb;
}

.contacts-table tbody tr.highlighted-contact:not(.red-row) {
  --row-bg: #dbeafe;
}

.contacts-table tbody tr.highlighted-contact td,
.contacts-table tbody tr.highlighted-contact .sticky-col {
  background-color: var(--row-bg) !important;
}

.contacts-table tbody tr.red-row td,
.contacts-table tbody tr.red-row .sticky-col {
  background-color: var(--row-bg) !important;
}

.contacts-table tbody td {
  padding: 14px 18px;
  border-bottom: 1px solid #e4e9f2;
  vertical-align: middle;
  white-space: normal;
  word-break: normal;
  color: #0f172a;
  background: var(--row-bg);
}

.contacts-table .actions-column {
  width: 150px;
  min-width: 140px;
  text-align: center;
  white-space: nowrap;
}

.contacts-table .data-column {
  width: 135px;
  min-width: 120px;
  white-space: nowrap;
}

.contacts-table .created-date-column {
  width: 105px;
  min-width: 95px;
}

.contacts-table .sticky-col {
  position: sticky;
  background-color: var(--row-bg);
  z-index: 5;
  box-shadow: 10px 0 18px -16px rgba(15, 23, 42, 0.45);
}

.contacts-table thead .sticky-col {
  background: linear-gradient(180deg, #f7f9fc 0%, #eef2f7 100%);
  z-index: 7;
}

.contacts-table .col-1 {
  left: 0;
  min-width: 160px;
  max-width: 200px;
}

.contacts-table .col-2 {
  left: 170px;
  min-width: 160px;
  max-width: 200px;
}

.contacts-table tbody .sticky-col {
  font-weight: 600;
  letter-spacing: 0.01em;
  background-clip: padding-box;
  background-color: var(--row-bg);
}

.contacts-table tbody .col-2 {
  box-shadow: 14px 0 22px -20px rgba(15, 23, 42, 0.45);
}

.contacts-table tbody .sticky-col::after {
  content: '';
  position: absolute;
  top: 0;
  right: -14px;
  width: 14px;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.25), rgba(148, 163, 184, 0));
  opacity: 0.45;
}

.contacts-table tbody .col-2::after {
  opacity: 0.6;
}

.order-link-cell {
  text-align: center;
}

.order-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #2563eb;
  text-decoration: none;
}

.order-link .material-icons {
  font-size: 20px;
}

.alert-note {
  margin-top: 6px;
  padding: 10px 12px;
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fecaca;
  border-radius: 6px;
  text-align: left;
  font-weight: 600;
}

.popup-row {
  --row-bg: #fff8e6;
}

.popup-row:hover {
  --row-bg: #ffeec7;
}

.lavorato-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #0b8136;
}

.acquistato-filter .lavorato-cell + .lavorato-cell {
  margin-left: 18px;
}

.lavorato-cell input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #22c55e;
}

.contacts-table tbody td.note-cell {
  position: relative;
  padding: 10px 14px;
  max-width: 320px;
  text-align: center;
  z-index: auto;
}
.contacts-table tbody td.note-cell:hover {
  z-index: 3000;
}

.note-icon-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid #dbe2f0;
  background: #f4f6fb;
  color: #4f46e5;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  z-index: 10;
}

.note-icon-button:hover,
.note-icon-button:focus-visible {
  border-color: #6366f1;
  background: #eef2ff;
  transform: translateY(-1px);
  outline: none;
  z-index: 3001;
}


.note-icon-button {
  background: linear-gradient(180deg, #f7f9ff 0%, #eef2ff 100%);
}

.note-icon-button--active {
  background:#16a34a;
  border-color: #16a34a;
  color: #ffffff;
  box-shadow: 0 12px 26px rgba(99, 102, 241, 0.35);
  z-index: 11;
}
.note-icon-button--active:hover,
.note-icon-button--active:focus-visible {
  z-index: 3001;
}

.note-icon-button::after {
  content: attr(data-note);
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translate(-50%, -6px);
  min-width: 120px;
  max-width: 360px;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.92);
  color: #f8fafc;
  font-size: 0.78rem;
  line-height: 1.45;
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.35);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  white-space: pre-wrap;
  word-break: break-word;
  z-index: 1001;
  pointer-events: none;
}

.note-icon-button:hover::after,
.note-icon-button:focus-visible::after {
  opacity: 1;
  transform: translate(-50%, 0);
}

.note-icon-button[data-note='']::after {
  display: none;
}


.note-editor-modal__content {
  max-width: 460px;
  width: 100%;
  border-radius: 22px;
  padding: 32px 36px;
  box-shadow: 0 28px 65px rgba(15, 23, 42, 0.18);
  background: linear-gradient(180deg, #ffffff 0%, #f5f7fb 100%);
}

.note-editor-modal__content h2 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f172a;
}

.note-editor-modal__meta {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin: 12px 0 26px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #475569;
  text-transform: capitalize;
}

.note-editor-modal__name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
}

.note-editor-modal__surname {
  color: #6366f1;
}

.note-editor-modal__field {
  padding-right: 4px;
}

.note-editor-modal__textarea {
  width: 94%;
  min-height: 160px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: #ffffff;
  font-size: 0.96rem;
  line-height: 1.6;
  color: #0f172a;
  padding: 14px 16px;
  margin: 0;
  resize: vertical;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.note-editor-modal__textarea:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.75);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);
  background: #f8faff;
}

.note-editor-modal__actions {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.note-modal-btn {
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  background: transparent;
  color: #1f2937;
  border: 1px solid rgba(148, 163, 184, 0.45);
}

.note-modal-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(148, 163, 184, 0.16);
  border-color: rgba(148, 163, 184, 0.7);
}

.note-modal-btn--ghost {
  color: #4f46e5;
  border-color: rgba(99, 102, 241, 0.45);
}

.note-modal-btn--ghost:hover {
  background: rgba(99, 102, 241, 0.12);
  transform: translateY(-1px);
}

.note-modal-btn--primary {
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  border: none;
  box-shadow: 0 10px 22px rgba(34, 197, 94, 0.35);
}

.note-modal-btn--primary:hover {
  box-shadow: 0 14px 32px rgba(34, 197, 94, 0.45);
}

.date-field-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 100px!important;
}

.date-field-container span {
  display: inline-block;
  min-width: 100px;
  font-variant-numeric: tabular-nums;
}

.hidden-date-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  cursor: pointer;
}

.date-reset-button {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  border: 1px solid rgba(239, 68, 68, 0.35);
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
  cursor: pointer;
  padding: 0;
}

.date-reset-button .material-icons {
  font-size: 16px;
}

.date-reset-button:hover {
  background: rgba(239, 68, 68, 0.2);
}

.match-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 12px;
  margin-right: 6px;
  border: 1px solid rgba(99, 102, 241, 0.35);
  background: rgba(129, 140, 248, 0.12);
  color: #4338ca;
}

.match-badge.match-strong {
  border-color: rgba(16, 185, 129, 0.45);
  background: rgba(16, 185, 129, 0.15);
  color: #047857;
}

.match-badge.match-email {
  border-color: rgba(37, 99, 235, 0.4);
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
}

.match-badge.match-phone {
  border-color: rgba(234, 179, 8, 0.4);
  background: rgba(250, 204, 21, 0.15);
  color: #b45309;
}

.match-badge.match-none {
  border-color: rgba(148, 163, 184, 0.6);
  background: rgba(226, 232, 240, 0.55);
  color: #475569;
}

.profile-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  margin-right: 6px;
  text-decoration: none;
  background: rgba(14, 165, 233, 0.12);
  color: #0ea5e9;
  transition: background 0.2s ease, color 0.2s ease;
}

.profile-link .material-icons {
  font-size: 20px;
}

.profile-link:hover {
  background: rgba(14, 165, 233, 0.2);
  color: #0369a1;
}

.buttons-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.buttons-container button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.buttons-container .material-icons {
  font-size: 22px;
  color: #1f2937;
}

.buttons-container .action-button--danger .material-icons {
  color: #dc2626;
}

.buttons-container .action-button--danger:hover .material-icons {
  color: #b91c1c;
}

.details-button {
  padding: 7px 16px;
  border-radius: 999px;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #fff;
  font-size: 0.82rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  box-shadow: 0 6px 12px rgba(34, 197, 94, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.details-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(34, 197, 94, 0.3);
}

.contacts-table .agenda-status-column,
.contacts-table tbody td.agenda-status-cell {
  width: 196px;
  min-width: 196px;
  text-align: center;
}

.contacts-table tbody td.agenda-status-cell {
  padding: 10px 12px;
  white-space: nowrap;
}

.agenda-status-controls {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.agenda-status-controls--updating {
  opacity: 0.65;
}

.agenda-status-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1.5px solid transparent;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.14);
  color: #64748b;
  cursor: pointer;
  transition: transform 0.12s ease, border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.agenda-status-button .material-icons {
  font-size: 18px;
}

.agenda-status-button:hover:not(:disabled),
.agenda-status-button:focus-visible {
  border-color: rgba(100, 116, 139, 0.4);
  color: #475569;
  transform: translateY(-1px);
  outline: none;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.18);
}

.agenda-status-controls--empty .agenda-status-button,
.agenda-status-controls--empty .agenda-status-button:hover:not(:disabled),
.agenda-status-controls--empty .agenda-status-button:focus-visible {
  border-color: transparent;
  background: rgba(148, 163, 184, 0.14);
  color: #64748b;
  box-shadow: none;
}

.agenda-status-button--active:hover:not(:disabled),
.agenda-status-button--active:focus-visible {
  border-color: var(--agenda-status-color);
  color: var(--agenda-status-color);
}

.agenda-status-button:disabled {
  cursor: wait;
}

.agenda-status-button--active {
  border-color: var(--agenda-status-color);
  color: var(--agenda-status-color);
  background: #ffffff;
  box-shadow: 0 5px 12px rgba(15, 23, 42, 0.14);
}

.agenda-status-button--da_confermare.agenda-status-button--active {
  background: rgba(245, 158, 11, 0.13);
}

.agenda-status-button--da_riprogrammare.agenda-status-button--active {
  background: rgba(219, 39, 119, 0.11);
}

.agenda-status-button--confermato.agenda-status-button--active {
  background: rgba(37, 99, 235, 0.11);
}

.agenda-status-button--fatto.agenda-status-button--active {
  background: rgba(22, 163, 74, 0.11);
}

.contacts-table .blue-separator {
  position: relative;
  padding: 0;
  width: 28px;
  min-width: 28px;
  background: var(--row-bg);
  border: none;
  pointer-events: none;
}

.contacts-table thead .blue-separator {
  background: transparent;
}

.contacts-table .blue-separator::before {
  content: '';
  position: absolute;
  top: 14%;
  bottom: 14%;
  left: 50%;
  width: 2px;
  transform: translateX(-50%);
  border-radius: 2px;
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.18) 0%, rgba(129, 140, 248, 0.08) 100%);
}

.contacts-table td select,
.contacts-table td input,
.contacts-table td textarea {
  width: 100%;
  max-width: 240px;
  padding: 7px 10px;
  border-radius: 10px;
  border: 1px solid #d7dde8;
  background: #ffffff;
  font-size: 0.85rem;
  color: #1f2937;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.contacts-table td select:focus,
.contacts-table td input:focus,
.contacts-table td textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.contacts-table td textarea {
  min-height: 60px;
  resize: vertical;
}


input[type="date"] {
color: rgb(0, 0, 0);
}

input[type="text"] {
margin-right: 30px;
}

.create-user-button {
  margin-right: 10px;
}

.csv-import-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 15px;
  border-radius: 13px;
  background: linear-gradient(135deg, #0f766e, #115e59);
  color: #ffffff;
  border: none;
  box-shadow: 0 12px 24px -18px rgba(15, 118, 110, 0.85);
}

.csv-import-button .material-icons {
  font-size: 20px;
}

.csv-import-modal {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 28px 20px;
}

.csv-import-modal__content {
  position: relative;
  width: min(1480px, 97vw);
  max-height: 94vh;
  overflow-y: auto;
  padding: 32px;
  border-radius: 28px;
  background:
    radial-gradient(circle at top right, rgba(14, 165, 233, 0.08), transparent 24%),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid rgba(203, 213, 225, 0.9);
  box-shadow: 0 30px 80px -42px rgba(15, 23, 42, 0.55);
}

.csv-import-modal__content .close {
  color: #64748b;
  font-size: 30px;
}

.csv-import-modal__content .close:hover {
  color: #0f172a;
}

.csv-import-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.csv-import-modal__header-copy {
  max-width: 760px;
}

.csv-import-modal__eyebrow {
  margin: 0 0 10px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #0f766e;
}

.csv-import-modal__header h2 {
  margin: 0;
  font-size: 2rem;
  line-height: 1.05;
  color: #0f172a;
}

.csv-import-modal__intro {
  margin: 12px 0 0;
  color: #475569;
  line-height: 1.6;
  max-width: 720px;
}

.csv-import-dashboard {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
  margin-bottom: 22px;
}

.csv-import-dashboard__card {
  padding: 16px 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #dce4ef;
  box-shadow: 0 16px 28px -26px rgba(15, 23, 42, 0.45);
}

.csv-import-dashboard__card span {
  display: block;
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 8px;
}

.csv-import-dashboard__card strong {
  font-size: 1.8rem;
  color: #0f172a;
}

.csv-import-accordion {
  margin-bottom: 22px;
}

.csv-import-accordion__toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #ffffff;
  color: #0f172a;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 14px 24px -24px rgba(15, 23, 42, 0.45);
}

.csv-import-accordion__toggle .material-icons {
  font-size: 20px;
  color: #0f766e;
}

.csv-import-accordion__panel {
  padding: 20px;
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.97), rgba(248, 250, 252, 0.98));
  border: 1px solid #d9e3ef;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

.csv-import-modal input[type="text"],
.csv-import-modal textarea,
.csv-import-modal select {
  margin-right: 0;
}

.csv-import-modal__controls {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 16px;
  margin-bottom: 16px;
}

.csv-import-modal__file,
.csv-import-modal__source {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 240px;
  color: #0f172a;
  font-weight: 600;
}

.csv-import-modal__file input {
  font-weight: 400;
  padding: 11px 0;
}

.csv-import-modal__textarea {
  width: 100%;
  min-height: 180px;
  max-height: 260px;
  resize: vertical;
  padding: 14px 16px;
  border-radius: 18px;
  border: 1px solid #d7e0ea;
  background: #ffffff;
  font-family: inherit;
}

.csv-import-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 0;
}

.csv-import-summary__item {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 12px 16px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #dbe5f1;
  color: #334155;
  box-shadow: 0 14px 24px -26px rgba(15, 23, 42, 0.35);
}

.csv-import-summary__item strong {
  font-size: 1.15rem;
  color: #0f172a;
}

.csv-import-warning {
  margin: 0 0 12px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
}

.csv-import-warning--light {
  background: #eff6ff;
  color: #1d4ed8;
  border-color: #bfdbfe;
}

.csv-archive-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding: 16px 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #dbe5f1;
  box-shadow: 0 18px 30px -30px rgba(15, 23, 42, 0.45);
  flex-wrap: wrap;
}

.csv-archive-toolbar__main {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 240px;
}

.csv-archive-toolbar__header {
  min-width: 220px;
}

.csv-archive-toolbar__header h3 {
  margin: 0 0 4px;
  font-size: 1rem;
  color: #0f172a;
}

.csv-archive-toolbar__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

.csv-active-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.csv-active-filter {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 7px 10px;
  border-radius: 999px;
  background: #eef6ff;
  border: 1px solid #bfdbfe;
  color: #1d4ed8;
  font-size: 0.8rem;
  font-weight: 600;
}

.csv-archive-search {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;
  color: #334155;
  font-size: 0.82rem;
  font-weight: 700;
}

.csv-archive-search .search-bar {
  min-width: 200px;
}

.csv-filter-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 18px;
  border-radius: 14px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #0f172a;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 14px 24px -24px rgba(15, 23, 42, 0.45);
}

.csv-filter-trigger .material-icons {
  font-size: 20px;
  color: #0f766e;
}

.csv-filter-trigger__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: #0f766e;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
}

.csv-filters-modal {
  position: absolute;
  inset: 0;
  z-index: 28;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 132px 24px 24px;
  background: rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(2px);
  border-radius: 28px;
}

.csv-filters-modal__content {
  width: min(440px, 100%);
  padding: 20px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #dbe5f1;
  box-shadow: 0 28px 50px -36px rgba(15, 23, 42, 0.6);
}

.csv-filters-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.csv-filters-modal__eyebrow {
  margin: 0 0 6px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #0f766e;
}

.csv-filters-modal__header h4 {
  margin: 0;
  font-size: 1.2rem;
  color: #0f172a;
}

.csv-filters-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid #dbe5f1;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
}

.csv-filters-modal__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

.csv-filters-modal__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
}

.csv-filters-modal__apply {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  height: 44px;
  padding: 0 18px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #0f766e, #115e59);
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
}

.csv-filter-reset {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 44px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #0f172a;
  font-weight: 700;
  cursor: pointer;
}

.csv-filter-reset:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.csv-import-table-wrap {
  max-height: 54vh;
  overflow: auto;
  margin-top: 0;
  border: 1px solid #dbe5f1;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 24px 40px -36px rgba(15, 23, 42, 0.55);
}

.csv-import-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  color: #0f172a;
  min-width: 1120px;
}

.csv-import-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 14px 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #eff4f9 100%);
  border-bottom: 1px solid #dbe5f1;
  text-align: left;
  font-size: 0.76rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #475569;
}

.csv-import-table tbody td {
  padding: 13px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  vertical-align: middle;
  white-space: nowrap;
}

.csv-import-table tbody tr:nth-child(even) td {
  background: #fbfdff;
}

.csv-import-table tbody tr:hover td {
  background: #f0f7ff;
}

.csv-import-table__row--existing td {
  background: #fffbeb;
}

.csv-import-table__row--existing:hover td {
  background: #fef3c7;
}

.csv-import-table__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 210px;
}

.csv-row-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  flex-shrink: 0;
}

.csv-row-indicator--existing {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  color: #92400e;
}

.csv-row-indicator .material-icons {
  font-size: 20px;
}

.csv-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  margin-top: 14px;
  padding: 12px 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #dbe5f1;
  box-shadow: 0 18px 26px -30px rgba(15, 23, 42, 0.5);
  flex-wrap: wrap;
}

.csv-pagination__summary {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  color: #475569;
  font-size: 0.9rem;
}

.csv-pagination__summary strong {
  color: #0f172a;
  font-size: 1rem;
}

.csv-pagination__controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.csv-pagination__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  height: 40px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid #dbe5f1;
  background: #ffffff;
  color: #0f172a;
  font-weight: 700;
  cursor: pointer;
}

.csv-pagination__button .material-icons {
  font-size: 20px;
}

.csv-pagination__button--active {
  background: linear-gradient(135deg, #0f766e, #115e59);
  border-color: transparent;
  color: #ffffff;
}

.csv-pagination__button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.csv-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 106px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.csv-status-badge .material-icons {
  font-size: 15px;
}

.csv-status-badge--pending {
  background: #e2e8f0;
  color: #334155;
}

.csv-status-badge--busy {
  background: #dbeafe;
  color: #1d4ed8;
}

.csv-status-badge--created {
  background: #dcfce7;
  color: #166534;
}

.csv-status-badge--existing {
  background: #fef3c7;
  color: #92400e;
}

.csv-create-row-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 9px 14px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #0f766e, #115e59);
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, opacity 0.2s ease, transform 0.2s ease;
}

.csv-create-row-button:hover {
  background: #115e59;
  transform: translateY(-1px);
}

.csv-create-row-button:disabled {
  background: #cbd5e1;
  color: #475569;
  cursor: not-allowed;
}

.csv-delete-row-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #fecaca;
  border-radius: 12px;
  background: #fff1f2;
  color: #dc2626;
  cursor: pointer;
}

.csv-delete-row-button .material-icons {
  font-size: 20px;
}

.csv-delete-row-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.csv-import-empty {
  margin-top: 0;
  padding: 22px 24px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.92);
  color: #475569;
  border: 1px solid #dbe5f1;
  box-shadow: 0 18px 30px -30px rgba(15, 23, 42, 0.45);
}

.csv-import-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 18px;
  flex-wrap: wrap;
}

.csv-import-actions--upload {
  margin-top: 0;
  margin-bottom: 0;
}

.csv-import-meta {
  margin: 0;
  font-size: 0.88rem;
  color: #64748b;
}

@media (max-width: 980px) {
  .csv-import-modal {
    padding: 16px 10px;
  }

  .csv-import-modal__content {
    width: 100%;
    padding: 22px 18px;
    border-radius: 22px;
  }

  .csv-import-modal__header {
    flex-direction: column;
  }

  .csv-import-accordion__toggle {
    width: 100%;
    justify-content: center;
  }

  .csv-archive-toolbar {
    padding: 18px;
  }

  .csv-archive-toolbar__actions {
    width: 100%;
    justify-content: flex-start;
  }

  .csv-archive-search,
  .csv-archive-search .search-bar {
    min-width: 100%;
  }

  .csv-filters-modal {
    padding: 90px 12px 12px;
  }

  .csv-filters-modal__content {
    width: 100%;
  }

  .csv-filters-modal__actions {
    flex-direction: column;
    align-items: stretch;
  }

  .csv-pagination {
    align-items: stretch;
  }

  .csv-pagination__controls {
    width: 100%;
  }

  .csv-filter-reset {
    width: 100%;
    justify-content: center;
  }

  .csv-filters-modal__apply {
    width: 100%;
  }
}

.reminder-toast {
  position: fixed;
  top: 24px;
  right: 24px;
  transform: translateY(0);
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 20px;
  background: rgba(18, 20, 31, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  color: #f7f8fb;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(8px);
  z-index: 2600;
  min-width: 260px;
  pointer-events: none;
}

.reminder-toast__header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.75;
}

.reminder-toast__header .material-icons {
  color: #ffffff;
}

.reminder-toast__name {
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.reminder-toast__meta {
  display: inline-flex;
  gap: 10px;
  font-size: 0.9rem;
  opacity: 0.85;
}

.reminder-toast__time {
  font-weight: 600;
}

.reminder-toast__date {
  font-weight: 500;
}

.reminder-toast .material-icons {
  font-size: 18px;
}

.reminder-toast-enter-active,
.reminder-toast-leave-active {
  transition: opacity 0.25s ease, transform 0.3s ease;
}

.reminder-toast-enter-from,
.reminder-toast-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.reminder-toast-enter-to,
.reminder-toast-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.agenda-button {
  padding: 12px 15px;
  border-radius: 13px;
  background-color: #f29214;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.agenda-button .material-icons {
  font-size: 20px;
}

.agenda-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}



.calendar-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.calendar-content {
  width: min(1100px, 95vw);
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 16px;
}

.calendar-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 60px 20px;
  color: #f2f3f8;
}

.calendar-loading__spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: agenda-spin 0.9s linear infinite;
}

.calendar-loading__label {
  font-size: 0.95rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.calendar-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 12px 0 18px;
}

.calendar-toolbar__group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.calendar-toolbar__button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #d6e2f5;
  background: #ffffff;
  color: #1d4ed8;
  font-weight: 500;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.calendar-toolbar__button:hover {
  background: rgba(33, 99, 214, 0.08);
  box-shadow: 0 2px 6px rgba(33, 99, 214, 0.18);
}

.calendar-toolbar__button .material-icons {
  font-size: 18px;
}

.calendar-toolbar__info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  color: #0f172a;
  font-weight: 500;
}

.calendar-range {
  font-size: 0.9rem;
}

.calendar-toolbar__badge {
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(234, 179, 8, 0.2);
  color: #92400e;
  font-size: 0.8rem;
  font-weight: 600;
}


.contact-reminder-modal__content {
  width: min(420px, 90vw);
  padding: 22px 24px 26px;
  background: #2b2b2f;
  color: #ffffff;
}

.contact-reminder-modal__content h2 {
  color: #ffffff;
}

.contact-reminder-modal__contact {
  margin: 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.9rem;
}

.contact-reminder-modal__name {
  font-weight: 600;
  color: #ffffff;
  text-transform: capitalize;
}

.contact-reminder-modal__email,
.contact-reminder-modal__phone {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.65);
}

.contact-reminder-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.contact-reminder-form__label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  color: #ffffff;
}

.contact-reminder-form__label input,
.contact-reminder-form__label textarea {
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 0.95rem;
  font-family: inherit;
  resize: vertical;
}

.contact-reminder-form__label textarea {
width: 93%;
}

.contact-reminder-form__label textarea {
  min-height: 60px;
  max-height: 80px;
}

.contact-reminder-form__label input::placeholder,
.contact-reminder-form__label textarea::placeholder {
  color: rgba(255, 255, 255, 0.55);
}

.contact-reminder-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 6px;
}

.contact-reminder-actions__btn {
  padding: 8px 16px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.contact-reminder-actions__btn--ghost {
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.contact-reminder-actions__btn--primary {
  background: #22c55e;
  color: #ffffff;
  box-shadow: 0 12px 26px -18px rgba(34, 197, 94, 0.85);
}

.contact-reminder-actions__btn--primary:disabled {
  opacity: 0.6;
  cursor: progress;
}

.contact-reminder-actions__btn:hover {
  transform: translateY(-1px);
}

.contact-reminder-actions__btn--ghost:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.35);
}

.contact-reminder-actions__btn--primary:hover {
  background: #16a34a;
}

.contact-reminder-modal__content .close {
  color: rgba(255, 255, 255, 0.75);
}

.contact-reminder-modal__content .close:hover {
  color: #ffffff;
}

@keyframes agenda-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.calendar-column {
  background: #f7f9fc;
  border-radius: 14px;
  border: 1px solid #d7e1f5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.calendar-column-header {
  padding: 16px 18px 12px;
  background: linear-gradient(120deg, #4f6fd6, #6f8ff0);
  color: #fff;
}

.calendar-date {
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 4px;
}

.calendar-date-secondary {
  font-size: 0.85rem;
  opacity: 0.85;
}

.calendar-event {
  display: flex;
  gap: 12px;
  padding: 14px 18px;
  border-top: 1px solid #e3eaf9;
}

.calendar-event:first-of-type {
  border-top: none;
}

.calendar-event--second {
  background: rgba(255, 152, 0, 0.12);
  border-left: 4px solid #ff9800;
}

.calendar-time {
  min-width: 56px;
  font-weight: 600;
  color: #3c4ba6;
}

.calendar-info {
  flex: 1;
}

.calendar-type {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #3c4ba6;
  margin-bottom: 4px;
}

.calendar-type--second {
  color: #ff9800;
}

.calendar-name {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 4px;
  color: #1c1c1c;
}

.calendar-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.85rem;
  color: #4c4c4c;
  word-break: break-word;
}

.calendar-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 999px;
  margin-top: 4px;
  background: rgba(79, 70, 229, 0.12);
  color: #4338ca;
  box-shadow: inset 0 0 0 1px rgba(79, 70, 229, 0.25);
}

.calendar-chip .material-icons {
  font-size: 16px;
  line-height: 1;
}

.calendar-chip--secondary {
  background: rgba(14, 165, 233, 0.12);
  color: #0ea5e9;
  box-shadow: inset 0 0 0 1px rgba(14, 165, 233, 0.25);
}

.calendar-empty {
  padding: 40px 20px;
  text-align: center;
  color: #4c4c4c;
}


</style>
<style scoped src="../../assets/css/staff-contacts-mobile.css"></style>
<style scoped src="../../assets/css/staff-contacts-search.css"></style>
<style scoped src="../../assets/css/staff-editor-dialog.css"></style>
<style scoped src="../../assets/css/staff-contact-dialog.css"></style>
